import React, { Component } from "react";
import firebase from "../Firebase";
import XLSX from "xlsx";
import Swal from "sweetalert2";
import {
  findEmployeeDocsByNik,
  pickLatestEmployeeDoc,
  resolveEmployeeDoc,
} from "../utils/employeeIdentity";

class Administrator extends Component {
  constructor() {
    super();
    this.db = firebase.firestore().collection("employees");
    this.state = {
      employees: [],
      employeesAll: [],
      isLoading: true,
      login_name: "",
      submiting: false,
      data_import: "",

      // ✅ TAMBAH: State untuk Excel upload
      selectedFile: "",
      isImporting: false,
      importPreview: [],
      showPreview: false,

      downloadFilter: "belum", // "belum" | "sudah" | "semua"

      // ✅ TAMBAH: Filter tanggal masuk
      tanggalMasukFrom: "",
      tanggalMasukTo: "",

      // ✅ TAMBAH: Filter status pengisian
      formSubmissionFilter: "semua", // "semua" | "belum_isi" | "form1_saja" | "form1_dan_2" | "form1_2_dan_3"
      trialSavingKeys: {},
    };

    this.downloadExcel = this.downloadExcel.bind(this);
    // ✅ TAMBAH: Bind methods untuk Excel
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.processExcelFile = this.processExcelFile.bind(this);
    this.importFromExcel = this.importFromExcel.bind(this);
  }

  setDownloadFilter = (filter) => {
    this.setState({ downloadFilter: filter });
  };

  // ✅ TAMBAH: Handler untuk filter tanggal masuk
  setTanggalMasukFrom = (date) => {
    this.setState({ tanggalMasukFrom: date });
  };

  setTanggalMasukTo = (date) => {
    this.setState({ tanggalMasukTo: date });
  };

  // ✅ TAMBAH: Handler untuk filter status pengisian
  setFormSubmissionFilter = (filter) => {
    this.setState({ formSubmissionFilter: filter });
  };

  onCollectionUpdate = (querySnapshot) => {
    try {
      if (!querySnapshot) {
        console.warn(
          "onCollectionUpdate: received null/undefined querySnapshot"
        );
        this.setState({ employees: [], employeesAll: [], isLoading: false });
        return;
      }

      const employees = [];
      const employeesAll = [];
      this.setState({
        isLoading: true,
      });

      querySnapshot.forEach((doc) => {
        const {
          // ✅ SEMUA FIELD yang diperlukan untuk PHP mapping
          nik,
          golongan_darah,
          nomor_ktp,
          nama_lengkap,
          nomor_kk,
          nomor_npwp,
          agama,
          jenis_kelamin,
          tempat_lahir,
          tanggal_lahir,
          tanggal_lahir_formatted,
          tanggal_masuk,
          status_perdata,
          orang_tua_nama_ayah,
          orang_tua_nama_ibu,
          kontak_darurat_nama,
          kontak_darurat_hubungan,
          kontak_darurat_hubungan_kerabat,
          kontak_darurat_no_telepon,
          province,
          regency,
          district,
          village,
          addressDetail,

          // ✅ TAMBAH: Alamat sekarang (AS*)
          ASprovince,
          ASregency,
          ASdistrict,
          ASvillage,
          ASaddressDetail,

          nama_pasangan,
          tempat_pernikahan,
          tanggal_pernikahan,
          tempat_lahir_pasangan,
          tanggal_lahir_pasangan,
          pekerjaan_pasangan,
          tempat_pasangan_bekerja,

          // ✅ Pengalaman kerja
          pengalaman_kerja_perusahaan_1,
          pengalaman_kerja_perusahaan_2,
          pengalaman_kerja_perusahaan_3,
          pengalaman_kerja_perusahaan_4,
          pengalaman_kerja_jabatan_1,
          pengalaman_kerja_jabatan_2,
          pengalaman_kerja_jabatan_3,
          pengalaman_kerja_jabatan_4,
          pengalaman_kerja_tanggal_mulai_1,
          pengalaman_kerja_tanggal_mulai_2,
          pengalaman_kerja_tanggal_mulai_3,
          pengalaman_kerja_tanggal_mulai_4,
          pengalaman_kerja_tanggal_selesai_1,
          pengalaman_kerja_tanggal_selesai_2,
          pengalaman_kerja_tanggal_selesai_3,
          pengalaman_kerja_tanggal_selesai_4,
          pengalaman_kerja_kota_1,
          pengalaman_kerja_kota_2,
          pengalaman_kerja_kota_3,
          pengalaman_kerja_kota_4,

          // ✅ Anak-anak
          anak_anak_nama_1,
          anak_anak_jenis_kelamin_1,
          anak_anak_tempat_lahir_1,
          anak_anak_tanggal_lahir_1,
          anak_anak_nama_2,
          anak_anak_jenis_kelamin_2,
          anak_anak_tempat_lahir_2,
          anak_anak_tanggal_lahir_2,
          anak_anak_nama_3,
          anak_anak_jenis_kelamin_3,
          anak_anak_tempat_lahir_3,
          anak_anak_tanggal_lahir_3,
          anak_anak_nama_4,
          anak_anak_jenis_kelamin_4,
          anak_anak_tempat_lahir_4,
          anak_anak_tanggal_lahir_4,

          // ✅ Orang tua
          orang_tua_tempat_lahir_ayah,
          orang_tua_tanggal_lahir_ayah,
          orang_tua_tempat_lahir_ibu,
          orang_tua_tanggal_lahir_ibu,

          // ✅ Saudara kandung
          saudara_kandung_nama_1,
          saudara_kandung_jenis_kelamin_1,
          saudara_kandung_tempat_lahir_1,
          saudara_kandung_tanggal_lahir_1,
          saudara_kandung_nama_2,
          saudara_kandung_jenis_kelamin_2,
          saudara_kandung_tempat_lahir_2,
          saudara_kandung_tanggal_lahir_2,
          saudara_kandung_nama_3,
          saudara_kandung_jenis_kelamin_3,
          saudara_kandung_tempat_lahir_3,
          saudara_kandung_tanggal_lahir_3,
          saudara_kandung_nama_4,
          saudara_kandung_jenis_kelamin_4,
          saudara_kandung_tempat_lahir_4,
          saudara_kandung_tanggal_lahir_4,

          // ✅ Mertua
          mertua_nama_ayah,
          mertua_tempat_lahir_ayah,
          mertua_tanggal_lahir_ayah,
          mertua_nama_ibu,
          mertua_tempat_lahir_ibu,
          mertua_tanggal_lahir_ibu,

          // ✅ Rekening & BPJS
          nomor_rekening_bank,
          nomor_kartu_bpjs_ketenagakerjaan,
          nomor_kartu_bpjs_kesehatan,
          keterangan_kartu_bpjs_kesehatan,
          keterangan_kartu_bpjs_ketenagakerjaan,

          // ✅ TAMBAH: Alamat sekarang fields (deprecated, tapi tetap diambil)
          alamat_sekarang_provinsi,
          alamat_sekarang_kota,
          alamat_sekarang_kecamatan,
          alamat_sekarang_desa,
          alamat_sekarang_alamat,

          // ✅ URL files
          foto_url,
          ktp_url,
          npwp_url,
          kk_url,
          cv_url,
          rekening_bank_url,
          mutasi_rekening_url,

          // ✅ TAMBAH: URL files yang kurang
          ijasah_url,
          transkrip_url,
          skck_url,
          bpjs_kesehatan_url,
          bpjs_ketenagakerjaan_url,
          keterangan_kesehatan_url,
          surat_pernyataan_kesanggupan_bpjs_url,
          keterangan_bpjs_tidak_aktif_url,
          peserta_jkn_url,
          iuran_jkn_url,
          vaksinasi_1_url,
          vaksinasi_2_url,
          vaksinasi_3_url,
          pemadanan_npwp_url,
          surat_lamaran_url,
          formulir_lamaran_pekerjaan_url,
          formulir_okb_url,
          foto_validate_by_ocr,
          ktp_validate_by_ocr,
          npwp_validate_by_ocr,
          kk_validate_by_ocr,
          cv_validate_by_ocr,
          rekening_bank_validate_by_ocr,
          mutasi_rekening_validate_by_ocr,
          ijasah_validate_by_ocr,
          transkrip_validate_by_ocr,
          skck_validate_by_ocr,
          bpjs_kesehatan_validate_by_ocr,
          bpjs_ketenagakerjaan_validate_by_ocr,
          keterangan_kesehatan_validate_by_ocr,
          peserta_jkn_validate_by_ocr,
          iuran_jkn_validate_by_ocr,
          vaksinasi_1_validate_by_ocr,
          vaksinasi_2_validate_by_ocr,
          vaksinasi_3_validate_by_ocr,
          pemadanan_npwp_validate_by_ocr,
          surat_lamaran_validate_by_ocr,
          formulir_lamaran_pekerjaan_validate_by_ocr,
          formulir_okb_validate_by_ocr,
          surat_pernyataan_kesanggupan_bpjs_validate_by_ocr,

          // ✅ Sertifikasi training
          nama_sertifikasi_1,
          nama_sertifikasi_2,
          nama_sertifikasi_3,
          nama_sertifikasi_4,
          lembaga_pemberi_1,
          lembaga_pemberi_2,
          lembaga_pemberi_3,
          lembaga_pemberi_4,
          sertifikasi_training_1_url,
          sertifikasi_training_2_url,
          sertifikasi_training_3_url,
          sertifikasi_training_4_url,

          // ✅ Kontak & sosmed
          nomor_hp,
          email,
          sosmed_facebook,
          sosmed_twitter,
          sosmed_linkedin,
          sosmed_instagram,

          // ✅ Pendidikan
          pendidikan_terakhir,
          pendidikan_nama_sekolah,
          pendidikan_jurusan,
          pendidikan_kursus,

          // ✅ TAMBAH: Data vaksinasi
          jenis_vaksin,
          tanggal_vaksin_1,
          lokasi_vaksin_1,
          tanggal_vaksin_2,
          lokasi_vaksin_2,
          tanggal_vaksin_3,
          lokasi_vaksin_3,

          // ✅ TAMBAH: Data form tambahan
          tanggal_berlaku_skck,
          bpjs_status,
          tanggal_pembuatan_surat_keterangan_sehat,
          status_iuran,

          // ✅ Status & metadata
          status,
          status_karyawan,
          username_admin,
          form_1_submitted,
          form_1_submitted_date,
          form_2_submitted,
          form_2_submitted_date,
          form_3_submitted,
          form_3_submitted_date,
          created_at,
          updated_at,
          is_excel_downloaded,
          is_reviewed_by_hr,
          trial,
        } = doc.data();

        // ✅ Filter untuk employees (hanya yang belum didownload)
        // if (is_excel_downloaded === "0") {
        // }
        employees.push({
          key: doc.id,
          doc,
          nik,
          nomor_ktp,
          nama_lengkap,
          jenis_kelamin,
          tempat_lahir,
          tanggal_lahir,
          tanggal_masuk,
          status_perdata,
          username_admin,
          form_1_submitted,
          form_2_submitted,
          form_3_submitted,
          is_excel_downloaded,
          trial: trial === true,
          // is_reviewed_by_hr,
        });

        // ✅ SEMUA DATA untuk employeesAll (sesuai dengan PHP mapping)
        employeesAll.push({
          key: doc.id,

          // ✅ Base data
          nik,
          nomor_ktp,
          nama_lengkap,
          nomor_kk,
          nomor_npwp,
          tempat_lahir,
          tanggal_lahir,
          tanggal_lahir_formatted,
          tanggal_masuk,

          // ✅ Data pribadi
          jenis_kelamin,
          golongan_darah,
          agama,
          nomor_hp,
          nomor_rekening_bank,
          status_perdata,

          // ✅ Kontak & sosmed
          email,
          sosmed_facebook,
          sosmed_twitter,
          sosmed_linkedin,
          sosmed_instagram,

          // ✅ BPJS
          nomor_kartu_bpjs_kesehatan,
          nomor_kartu_bpjs_ketenagakerjaan,
          keterangan_kartu_bpjs_kesehatan,
          keterangan_kartu_bpjs_ketenagakerjaan,

          // ✅ Alamat
          province,
          regency,
          district,
          village,
          addressDetail,
          ASprovince,
          ASregency,
          ASdistrict,
          ASvillage,
          ASaddressDetail,
          alamat_sekarang_provinsi,
          alamat_sekarang_kota,
          alamat_sekarang_kecamatan,
          alamat_sekarang_desa,
          alamat_sekarang_alamat,

          // ✅ Data kontak darurat
          kontak_darurat_nama,
          kontak_darurat_hubungan,
          kontak_darurat_hubungan_kerabat,
          kontak_darurat_no_telepon,

          // ✅ Data pendidikan
          pendidikan_terakhir,
          pendidikan_nama_sekolah,
          pendidikan_jurusan,
          pendidikan_kursus,

          // ✅ Data diri lanjutan
          nama_pasangan,
          tempat_pernikahan,
          tanggal_pernikahan,
          tempat_lahir_pasangan,
          tanggal_lahir_pasangan,
          pekerjaan_pasangan,
          tempat_pasangan_bekerja,

          // ✅ Data keluarga
          orang_tua_nama_ayah,
          orang_tua_tempat_lahir_ayah,
          orang_tua_tanggal_lahir_ayah,
          orang_tua_nama_ibu,
          orang_tua_tempat_lahir_ibu,
          orang_tua_tanggal_lahir_ibu,

          // ✅ Anak
          anak_anak_nama_1,
          anak_anak_jenis_kelamin_1,
          anak_anak_tempat_lahir_1,
          anak_anak_tanggal_lahir_1,
          anak_anak_nama_2,
          anak_anak_jenis_kelamin_2,
          anak_anak_tempat_lahir_2,
          anak_anak_tanggal_lahir_2,
          anak_anak_nama_3,
          anak_anak_jenis_kelamin_3,
          anak_anak_tempat_lahir_3,
          anak_anak_tanggal_lahir_3,
          anak_anak_nama_4,
          anak_anak_jenis_kelamin_4,
          anak_anak_tempat_lahir_4,
          anak_anak_tanggal_lahir_4,

          // ✅ Saudara
          saudara_kandung_nama_1,
          saudara_kandung_jenis_kelamin_1,
          saudara_kandung_tempat_lahir_1,
          saudara_kandung_tanggal_lahir_1,
          saudara_kandung_nama_2,
          saudara_kandung_jenis_kelamin_2,
          saudara_kandung_tempat_lahir_2,
          saudara_kandung_tanggal_lahir_2,
          saudara_kandung_nama_3,
          saudara_kandung_jenis_kelamin_3,
          saudara_kandung_tempat_lahir_3,
          saudara_kandung_tanggal_lahir_3,
          saudara_kandung_nama_4,
          saudara_kandung_jenis_kelamin_4,
          saudara_kandung_tempat_lahir_4,
          saudara_kandung_tanggal_lahir_4,

          // ✅ Mertua
          mertua_nama_ayah,
          mertua_tempat_lahir_ayah,
          mertua_tanggal_lahir_ayah,
          mertua_nama_ibu,
          mertua_tempat_lahir_ibu,
          mertua_tanggal_lahir_ibu,

          // ✅ Data pengalaman kerja
          pengalaman_kerja_perusahaan_1,
          pengalaman_kerja_perusahaan_2,
          pengalaman_kerja_perusahaan_3,
          pengalaman_kerja_perusahaan_4,
          pengalaman_kerja_jabatan_1,
          pengalaman_kerja_jabatan_2,
          pengalaman_kerja_jabatan_3,
          pengalaman_kerja_jabatan_4,
          pengalaman_kerja_tanggal_mulai_1,
          pengalaman_kerja_tanggal_mulai_2,
          pengalaman_kerja_tanggal_mulai_3,
          pengalaman_kerja_tanggal_mulai_4,
          pengalaman_kerja_tanggal_selesai_1,
          pengalaman_kerja_tanggal_selesai_2,
          pengalaman_kerja_tanggal_selesai_3,
          pengalaman_kerja_tanggal_selesai_4,
          pengalaman_kerja_kota_1,
          pengalaman_kerja_kota_2,
          pengalaman_kerja_kota_3,
          pengalaman_kerja_kota_4,

          // ✅ Sertifikasi training
          nama_sertifikasi_1,
          nama_sertifikasi_2,
          nama_sertifikasi_3,
          nama_sertifikasi_4,
          lembaga_pemberi_1,
          lembaga_pemberi_2,
          lembaga_pemberi_3,
          lembaga_pemberi_4,

          // ✅ Data vaksinasi
          jenis_vaksin,
          tanggal_vaksin_1,
          lokasi_vaksin_1,
          tanggal_vaksin_2,
          lokasi_vaksin_2,
          tanggal_vaksin_3,
          lokasi_vaksin_3,

          // ✅ Data form tambahan
          tanggal_berlaku_skck,
          bpjs_status,
          tanggal_pembuatan_surat_keterangan_sehat,
          status_iuran,

          // ✅ URL berkas gambar
          foto_url,
          ktp_url,
          npwp_url,
          kk_url,
          cv_url,
          sertifikasi_training_1_url,
          sertifikasi_training_2_url,
          sertifikasi_training_3_url,
          sertifikasi_training_4_url,
          rekening_bank_url,
          mutasi_rekening_url,
          ijasah_url,
          transkrip_url,
          skck_url: skck_url, // ✅ Mapping skck_url ke skck_url untuk konsistensi
          bpjs_kesehatan_url,
          bpjs_ketenagakerjaan_url,
          keterangan_kesehatan_url,
          surat_pernyataan_kesanggupan_bpjs_url,
          keterangan_bpjs_tidak_aktif_url,
          peserta_jkn_url,
          iuran_jkn_url,
          vaksinasi_1_url,
          vaksinasi_2_url,
          vaksinasi_3_url,
          pemadanan_npwp_url,
          surat_lamaran_url,
          formulir_lamaran_pekerjaan_url,
          formulir_okb_url,
          foto_validate_by_ocr,
          ktp_validate_by_ocr,
          npwp_validate_by_ocr,
          kk_validate_by_ocr,
          cv_validate_by_ocr,
          rekening_bank_validate_by_ocr,
          mutasi_rekening_validate_by_ocr,
          ijasah_validate_by_ocr,
          transkrip_validate_by_ocr,
          skck_validate_by_ocr,
          bpjs_kesehatan_validate_by_ocr,
          bpjs_ketenagakerjaan_validate_by_ocr,
          keterangan_kesehatan_validate_by_ocr,
          peserta_jkn_validate_by_ocr,
          iuran_jkn_validate_by_ocr,
          vaksinasi_1_validate_by_ocr,
          vaksinasi_2_validate_by_ocr,
          vaksinasi_3_validate_by_ocr,
          pemadanan_npwp_validate_by_ocr,
          surat_lamaran_validate_by_ocr,
          formulir_lamaran_pekerjaan_validate_by_ocr,
          formulir_okb_validate_by_ocr,
          surat_pernyataan_kesanggupan_bpjs_validate_by_ocr,

          // ✅ Data metadata
          status_karyawan,
          status,
          form_1_submitted,
          form_1_submitted_date,
          form_2_submitted,
          form_2_submitted_date,
          form_3_submitted,
          form_3_submitted_date,
          created_at,
          updated_at,
          username_admin,
          is_excel_downloaded,
          is_reviewed_by_hr,
        });
      });

      this.setState({
        employees,
        employeesAll,
        isLoading: false,
      });
    } catch (error) {
      console.error(
        "❌ Error processing querySnapshot in onCollectionUpdate:",
        error
      );
      this.setState({
        employees: [],
        employeesAll: [],
        isLoading: false,
      });
    }
    // console.log(employees);
  };

  componentDidMount() {
    this.cekLogin();
    this.getCurrentDate();
    this.loadEmployees();
  }

  componentWillUnmount() {
    // Tidak pakai onSnapshot — tidak ada listener yang perlu di-unsubscribe
  }

  /** Load sekali via get() (hemat read vs onSnapshot realtime full collection). */
  loadEmployees = async () => {
    this.setState({ isLoading: true });
    try {
      const snapshot = await this.db.get();
      this.onCollectionUpdate(snapshot);
    } catch (error) {
      console.error("Firestore load employees error:", error);
      this.setState({ employees: [], employeesAll: [], isLoading: false });
      Swal.fire({
        title: "Gagal Memuat Data",
        html:
          "Tidak dapat membaca collection employees.<br><br>" +
          (error && error.message
            ? `<code>${error.message}</code>`
            : "Cek Firestore rules / koneksi."),
        icon: "error",
        confirmButtonText: "Oke",
      });
    }
  };

  cekLogin = () => {
    const login = localStorage.getItem("login");
    if (login == null) {
      // Ini sudah login, masuk ke form
      this.props.history.push("/administrator/login");
    } else {
      this.setState({
        login_name: JSON.parse(login)[0].name,
      });
    }
  };

  doLogout = () => {
    var confirm = window.confirm("Yakin mau keluar?");
    if (confirm) {
      localStorage.removeItem("login");
      window.location.reload();
    }
  };

  kasihNol = (data) => {
    if (data < 10) {
      return "0" + data;
    } else {
      return data;
    }
  };

  // updateAllEmployees = async () => {
  //   if (
  //     !window.confirm(
  //       "Yakin ingin menambahkan / memperbarui field pada semua dokumen karyawan? (tidak bisa dibatalkan)"
  //     )
  //   )
  //     return;

  //   this.setState({ isLoading: true });
  //   try {
  //     const snapshot = await this.db.get();
  //     const ops = [];

  //     snapshot.forEach((doc) => {
  //       // const data = doc.data() || {};
  //       const updateData = {
  //         // cv_url: "",
  //         rekening_bank_check_status: "",
  //         mutasi_rekening_check_status: "",
  //         ijasah_check_status: "",
  //         transkrip_check_status: "",
  //         skck_check_status: "",
  //         bpjs_kesehatan_check_status: "",
  //         bpjs_ketenagakerjaan_check_status: "",
  //         keterangan_kesehatan_check_status: "",
  //         surat_pernyataan_kesanggupan_bpjs_check_status: "",
  //         keterangan_bpjs_tidak_aktif_check_status: "",
  //         peserta_jkn_check_status: "",
  //         iuran_jkn_check_status: "",
  //         vaksinasi_1_check_status: "",
  //         vaksinasi_2_check_status: "",
  //         vaksinasi_3_check_status: "",
  //         pemadanan_npwp_check_status: "",
  //         surat_lamaran_check_status: "",
  //         formulir_lamaran_pekerjaan_check_status: "",
  //         formulir_okb_check_status: "",
  //       };

  //       // set with merge true — hanya menambahkan/menimpa field yang disebut
  //       ops.push(this.db.doc(doc.id).set(updateData, { merge: true }));
  //     });

  //     // Execute in small batches to avoid overwhelming the client / Firestore
  //     const BATCH_SIZE = 50;
  //     for (let i = 0; i < ops.length; i += BATCH_SIZE) {
  //       await Promise.all(ops.slice(i, i + BATCH_SIZE));
  //     }

  //     Swal.fire("Selesai", "Semua dokumen berhasil diperbarui.", "success");
  //   } catch (error) {
  //     console.error("Error updating employees:", error);
  //     Swal.fire(
  //       "Error",
  //       "Terjadi kesalahan saat update. Cek console.",
  //       "error"
  //     );
  //   } finally {
  //     this.setState({ isLoading: false });
  //   }
  // };

  deleteAllWithNpwpUrl = async () => {
    if (
      !window.confirm(
        "Yakin ingin menghapus semua data yang memiliki field npwp_url di Firestore? Tindakan ini tidak bisa dibatalkan!"
      )
    ) {
      return;
    }

    this.setState({ isLoading: true });
    try {
      const snapshot = await this.db.where("status", "==", "dibuat").get();
      if (snapshot.empty) {
        alert("Tidak ada data dengan field npwp_url.");
        this.setState({ isLoading: false });
        return;
      }

      let deleteCount = 0;
      for (const doc of snapshot.docs) {
        await doc.ref.delete();
        deleteCount++;
      }
      alert(`Berhasil menghapus ${deleteCount} data dengan field npwp_url.`);
    } catch (error) {
      console.error("Gagal menghapus data:", error);
      alert("Terjadi error saat menghapus data. Cek console.");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  date = () => {
    const hmm = this;
    const today = new Date();
    const time =
      hmm.kasihNol(today.getHours()) +
      ":" +
      hmm.kasihNol(today.getMinutes()) +
      ":" +
      hmm.kasihNol(today.getSeconds());
    const date =
      hmm.kasihNol(today.getDate()) +
      "/" +
      hmm.kasihNol(today.getMonth() + 1) +
      "/" +
      hmm.kasihNol(today.getFullYear());
    hmm.setState({
      date: date,
      time: time,
    });
  };

  getCurrentDate = () => {
    const hmm = this;
    hmm.date();
    setInterval(function () {
      hmm.date();
    }, 1000);
  };

  // ✅ TAMBAH: Handler untuk file selection
  handleFileSelect = (e) => {
    const file = e.target.files[0];

    if (!file) {
      this.setState({
        selectedFile: "",
        importPreview: [],
        showPreview: false,
      });
      return;
    }

    // ✅ Validasi file type
    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        title: "File Tidak Valid!",
        text: "Hanya file Excel (.xls, .xlsx) yang diperbolehkan",
        icon: "error",
        confirmButtonText: "OK",
      });
      e.target.value = "";
      return;
    }

    console.log("📁 MCU File selected:", {
      name: file.name,
      size: file.size,
      type: file.type,
    });

    this.setState({
      selectedFile: file,
    });

    // ✅ Auto-process file MCU
    this.processExcelFile(file);
  };

  // ✅ TAMBAH: Function untuk process Excel file
  processExcelFile = (file) => {
    this.setState({ isImporting: true });

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
        });

        console.log("📊 MCU Excel data parsed:", jsonData);

        // ✅ Langsung proses sebagai MCU data
        const processedData = this.validateMCUExcelData(jsonData);

        this.setState({
          importPreview: processedData.validData,
          showPreview: true,
          isImporting: false,
        });

        if (processedData.errors.length > 0) {
          Swal.fire({
            title: "Peringatan MCU Import!",
            html: `
            <div style="text-align: left;">
              <p><strong>Data MCU berhasil diproses:</strong> ${
                processedData.validData.length
              } baris</p>
              <p><strong>Data bermasalah:</strong> ${
                processedData.errors.length
              } baris</p>
              <br>
              <p><strong>Detail Error:</strong></p>
              <ul style="max-height: 200px; overflow-y: auto;">
                ${processedData.errors
                  .slice(0, 10)
                  .map(
                    (error) => `<li>Baris ${error.row}: ${error.message}</li>`
                  )
                  .join("")}
                ${
                  processedData.errors.length > 10
                    ? `<li>... dan ${
                        processedData.errors.length - 10
                      } error lainnya</li>`
                    : ""
                }
              </ul>
            </div>
          `,
            icon: "warning",
            confirmButtonText: "Lanjutkan",
          });
        } else {
          Swal.fire({
            title: "File MCU Berhasil Diproses!",
            text: `${processedData.validData.length} data MCU siap untuk diimport`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("❌ Error processing MCU Excel file:", error);

        this.setState({
          isImporting: false,
          importPreview: [],
          showPreview: false,
        });

        Swal.fire({
          title: "Error MCU Import!",
          text: "Gagal memproses file Excel MCU. Pastikan format file benar.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    reader.onerror = () => {
      this.setState({ isImporting: false });
      Swal.fire({
        title: "Error!",
        text: "Gagal membaca file MCU",
        icon: "error",
        confirmButtonText: "OK",
      });
    };

    reader.readAsArrayBuffer(file);
  };

  excelDateToJSDateForLogin = (serial) => {
    // Excel mulai dari 1900-01-01, tapi ada bug leap year (Feb 29, 1900 dianggap ada)
    // Jadi perlu dikurangi 25569 untuk shift ke epoch JS (1970-01-01)
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400; // detik
    const date_info = new Date(utc_value * 1000);

    // Format dd/mm/yyyy
    const day = String(date_info.getDate()).padStart(2, "0");
    const month = String(date_info.getMonth() + 1).padStart(2, "0"); // bulan mulai dari 0
    const year = date_info.getFullYear();

    return `${day}${month}${year}`;
  };

  excelDateToJSDate = (serial) => {
    // Excel mulai dari 1900-01-01, tapi ada bug leap year (Feb 29, 1900 dianggap ada)
    // Jadi perlu dikurangi 25569 untuk shift ke epoch JS (1970-01-01)
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400; // detik
    const date_info = new Date(utc_value * 1000);

    // Format dd/mm/yyyy
    const day = String(date_info.getDate()).padStart(2, "0");
    const month = String(date_info.getMonth() + 1).padStart(2, "0"); // bulan mulai dari 0
    const year = date_info.getFullYear();

    // return `${day}/${month}/${year}`;
    return `${year}-${month}-${day}`;
  };

  toDDMMYYYY = (input) => {
    if (!input && input !== 0) return "";

    try {
      let date;

      // 1) Jika sudah Date
      if (input instanceof Date) {
        date = input;
      }
      // 2) Jika serial number Excel (number)
      else if (typeof input === "number") {
        const excelEpoch = new Date(1900, 0, 1);
        const daysSinceEpoch = input - 2; // perbaiki bug excel leap 1900
        date = new Date(
          excelEpoch.getTime() + daysSinceEpoch * 24 * 60 * 60 * 1000
        );
      }
      // 3) Jika string MM/DD/YYYY
      else if (typeof input === "string") {
        const s = input.trim();
        // Cek format MM/DD/YYYY
        const mmddyyyy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (mmddyyyy) {
          const month = Number.parseInt(mmddyyyy[1], 10); // Bagian pertama adalah bulan
          const day = Number.parseInt(mmddyyyy[2], 10); // Bagian kedua adalah hari
          const year = Number.parseInt(mmddyyyy[3], 10); // Bagian ketiga adalah tahun

          if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
            // Format sebagai DDMMYYYY (hari+bulan+tahun)
            return (
              String(day).padStart(2, "0") +
              String(month).padStart(2, "0") +
              String(year)
            );
          }
        }
        // ISO "YYYY-MM-DD"
        const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (iso) {
          const year = iso[1];
          const month = iso[2];
          const day = iso[3];
          return `${day}${month}${year}`;
        }
        // fallback: Date object parse
        const parsed = new Date(s);
        if (!isNaN(parsed.getTime())) {
          const dd = String(parsed.getDate()).padStart(2, "0");
          const mm = String(parsed.getMonth() + 1).padStart(2, "0");
          const yyyy = parsed.getFullYear();
          return `${dd}${mm}${yyyy}`;
        }
        return "";
      } else {
        return "";
      }

      // Untuk Date object/hasil serial
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      return `${dd}${mm}${yyyy}`;
    } catch (err) {
      console.warn("toDDMMYYYY error:", input, err);
      return "";
    }
  };

  // ✅ TAMBAH: Function untuk validasi data Excel MCU
  validateMCUExcelData = (jsonData) => {
    const validData = [];
    const errors = [];

    if (jsonData.length < 2) {
      errors.push({
        row: 1,
        message: "File Excel harus memiliki minimal header dan 1 baris data",
      });
      return { validData, errors };
    }

    // ✅ Mapping kolom dari header row
    const headerRow = jsonData[0];
    const columnMapping = {};

    headerRow.forEach((header, index) => {
      if (header) {
        columnMapping[header.trim()] = index;
      }
    });

    console.log("📋 MCU Excel column mapping:", columnMapping);

    // ✅ Validasi required columns
    const requiredColumns = [
      "No KTP",
      "Nama Lengkap",
      "Jenis Kelamin",
      "Tanggal lahir",
      "Status Karyawan",
    ];

    const missingColumns = requiredColumns.filter(
      (col) => !(col in columnMapping)
    );
    if (missingColumns.length > 0) {
      errors.push({
        row: 1,
        message: `Kolom wajib tidak ditemukan: ${missingColumns.join(", ")}`,
      });
      return { validData, errors };
    }

    // ✅ Process data rows
    for (let i = 1; i < jsonData.length; i++) {
      const row = jsonData[i];
      const rowNumber = i + 1;

      // ✅ Skip empty rows
      if (!row || row.length === 0 || !row[columnMapping["No KTP"]]) {
        continue;
      }

      try {
        const noKtp = String(row[columnMapping["No KTP"]] || "").trim();
        const namaLengkap = String(
          row[columnMapping["Nama Lengkap"]] || ""
        ).trim();
        const jenisKelamin = String(
          row[columnMapping["Jenis Kelamin"]] || ""
        ).trim();
        // Ambil cell tanggal lahir (bisa number/Date/string)
        let rawTanggalCell = row[columnMapping["Tanggal lahir"]];
        console.log(rawTanggalCell);

        // // Jika number (Excel serial), convert ke string tanggal
        // if (typeof rawTanggalCell === "number") {
        //   // Gunakan helper formatExcelDate untuk dapatkan "YYYY-MM-DD"
        //   rawTanggalCell = this.excelDateToJSDateForLogin(rawTanggalCell);
        // }
        // // Jika Date object, juga convert ke string
        // if (rawTanggalCell instanceof Date) {
        //   rawTanggalCell = this.excelDateToJSDateForLogin(rawTanggalCell);
        // }
        // console.log(
        //   "Tipe data rawTanggalCell:",
        //   typeof rawTanggalCell,
        //   rawTanggalCell
        // );
        // tanggal_lahir_formatted = YYYY-MM-DD (untuk keperluan lain)
        // const tanggalLahirFormatted = this.excelDateToJSDate(rawTanggalCell);

        // tanggal untuk NIK/password => DDMMYYYY (gunakan helper robust)
        const tanggalLahirForNik =
          this.excelDateToJSDateForLogin(rawTanggalCell) || "";

        const statusKaryawan = String(
          row[columnMapping["Status Karyawan"]] || ""
        )
          .trim()
          .toLowerCase();

        // ✅ Validasi No KTP
        if (!noKtp || noKtp.length !== 16) {
          errors.push({
            row: rowNumber,
            message: `No KTP tidak valid (harus 16 digit): "${noKtp}"`,
          });
          continue;
        }

        // ✅ Validasi Nama Lengkap
        if (!namaLengkap) {
          errors.push({
            row: rowNumber,
            message: "Nama Lengkap tidak boleh kosong",
          });
          continue;
        }

        // ✅ Validasi Jenis Kelamin
        const validGenders = ["laki-laki", "perempuan", "l", "p"];
        if (
          !jenisKelamin ||
          !validGenders.includes(jenisKelamin.toLowerCase())
        ) {
          errors.push({
            row: rowNumber,
            message: `Jenis Kelamin tidak valid: "${jenisKelamin}"`,
          });
          continue;
        }

        // ✅ Validasi Status Karyawan
        const validStatuses = [
          "staff",
          "nonstaff",
          "nonstaff helper",
          "pkl/magang",
        ];
        if (!statusKaryawan || !validStatuses.includes(statusKaryawan)) {
          errors.push({
            row: rowNumber,
            message: `Status karyawan tidak valid (harus: ${validStatuses
              .map((status) => `"${status}"`)
              .join("/")}): "${statusKaryawan}"`,
          });
          continue;
        }

        // // ✅ Format tanggal lahir untuk NIK
        // let tanggalLahirForNik = "";
        // const rawTanggalCell = row[columnMapping["Tanggal lahir"]];
        // if (rawTanggalCell) {
        //   tanggalLahirForNik =
        //     this.toDDMMYYYY(rawTanggalCell) ||
        //     this.toDDMMYYYY(tanggalLahir) ||
        //     "";
        // } else {
        //   tanggalLahirForNik = this.toDDMMYYYY(tanggalLahir) || "";
        // }

        // ✅ Format semua tanggal menggunakan helper function
        const tanggalLahirAyah =
          row[columnMapping["Tanggal lahir ayah"]] !== undefined &&
          row[columnMapping["Tanggal lahir ayah"]] !== null &&
          row[columnMapping["Tanggal lahir ayah"]] !== ""
            ? this.excelDateToJSDate(row[columnMapping["Tanggal lahir ayah"]])
            : "";

        const tanggalLahirIbu =
          row[columnMapping["Tanggal lahir ibu"]] !== undefined &&
          row[columnMapping["Tanggal lahir ibu"]] !== null &&
          row[columnMapping["Tanggal lahir ibu"]] !== ""
            ? this.excelDateToJSDate(row[columnMapping["Tanggal lahir ibu"]])
            : "";

        const tanggalMulaiKerja1 =
          row[columnMapping["Mulai bekerja perusahaan 1"]] !== undefined &&
          row[columnMapping["Mulai bekerja perusahaan 1"]] !== null &&
          row[columnMapping["Mulai bekerja perusahaan 1"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Mulai bekerja perusahaan 1"]]
              )
            : "";

        const tanggalSelesaiKerja1 =
          row[columnMapping["Berhenti bekerja perusahaan 1"]] !== undefined &&
          row[columnMapping["Berhenti bekerja perusahaan 1"]] !== null &&
          row[columnMapping["Berhenti bekerja perusahaan 1"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Berhenti bekerja perusahaan 1"]]
              )
            : "";

        const tanggalMulaiKerja2 =
          row[columnMapping["Mulai bekerja perusahaan 2"]] !== undefined &&
          row[columnMapping["Mulai bekerja perusahaan 2"]] !== null &&
          row[columnMapping["Mulai bekerja perusahaan 2"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Mulai bekerja perusahaan 2"]]
              )
            : "";

        const tanggalSelesaiKerja2 =
          row[columnMapping["Berhenti bekerja perusahaan 2"]] !== undefined &&
          row[columnMapping["Berhenti bekerja perusahaan 2"]] !== null &&
          row[columnMapping["Berhenti bekerja perusahaan 2"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Berhenti bekerja perusahaan 2"]]
              )
            : "";

        const tanggalMulaiKerja3 =
          row[columnMapping["Mulai bekerja perusahaan 3"]] !== undefined &&
          row[columnMapping["Mulai bekerja perusahaan 3"]] !== null &&
          row[columnMapping["Mulai bekerja perusahaan 3"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Mulai bekerja perusahaan 3"]]
              )
            : "";

        const tanggalSelesaiKerja3 =
          row[columnMapping["Berakhir bekerja perusahaan 3"]] !== undefined &&
          row[columnMapping["Berakhir bekerja perusahaan 3"]] !== null &&
          row[columnMapping["Berakhir bekerja perusahaan 3"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Berakhir bekerja perusahaan 3"]]
              )
            : "";

        const tanggalMulaiKerja4 =
          row[columnMapping["Mulai bekerja perusahaan 4"]] !== undefined &&
          row[columnMapping["Mulai bekerja perusahaan 4"]] !== null &&
          row[columnMapping["Mulai bekerja perusahaan 4"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Mulai bekerja perusahaan 4"]]
              )
            : "";

        const tanggalSelesaiKerja4 =
          row[columnMapping["Berakhir bekerja perusahaan 4"]] !== undefined &&
          row[columnMapping["Berakhir bekerja perusahaan 4"]] !== null &&
          row[columnMapping["Berakhir bekerja perusahaan 4"]] !== ""
            ? this.excelDateToJSDate(
                row[columnMapping["Berakhir bekerja perusahaan 4"]]
              )
            : "";

        // ✅ Collect MCU data sesuai dengan PHP version
        const mcuData = {
          // ✅ Base data untuk login
          nik: noKtp, // Menggunakan No KTP sebagai NIK
          tanggal_lahir: tanggalLahirForNik,
          status_karyawan: statusKaryawan,

          // ✅ Data MCU lengkap dengan suffix _mcu
          jenis_kelamin_mcu:
            jenisKelamin.toLowerCase() === "laki-laki"
              ? "L"
              : jenisKelamin.toLowerCase() === "perempuan"
              ? "P"
              : jenisKelamin.toUpperCase(),
          nomor_ktp_mcu: noKtp,
          nama_lengkap_mcu: namaLengkap,
          tempat_lahir_mcu: String(
            row[columnMapping["Tempat Lahir"]] || ""
          ).trim(),
          tanggal_lahir_mcu: tanggalLahirForNik, // simpan juga ddmmyyyy di field MCU
          alamat_ktp_mcu: String(row[columnMapping["Alamat KTP"]] || "").trim(),
          alamat_domisili_mcu: String(
            row[columnMapping["Alamat Lengkap Domisili"]] || ""
          ).trim(),
          nomor_hp_mcu: String(row[columnMapping["No Telp"]] || "").trim(),
          email_mcu: String(row[columnMapping["Email"]] || "").trim(),
          agama_mcu: String(row[columnMapping["Agama"]] || "").trim(),
          nomor_rekening_bank_mcu: String(
            row[
              columnMapping["Nomor Rekening Buku Tabungan Mandiri yang Aktif"]
            ] || ""
          ).trim(),

          // ✅ Data BPJS
          nomor_kartu_bpjs_kesehatan_mcu: String(
            row[columnMapping["Nomor BPJS Kesehatan Aktif"]] || ""
          ).trim(),
          nomor_kartu_bpjs_ketenagakerjaan_mcu: String(
            row[columnMapping["Nomor kartu BPJS Ketenagakerjaan"]] || ""
          ).trim(),

          // ✅ Data kontak darurat
          kontak_darurat_nama_mcu: String(
            row[columnMapping["Nama Kontak darurat"]] || ""
          ).trim(),
          kontak_darurat_hubungan_mcu: String(
            row[columnMapping["Hubungan dengan kontak darurat"]] || ""
          ).trim(),
          kontak_darurat_no_telepon_mcu: String(
            row[columnMapping["Nomor telp kontak darurat"]] || ""
          ).trim(),

          // ✅ Data pendidikan
          pendidikan_terakhir_mcu: String(
            row[columnMapping["Pendidikan terakhir"]] || ""
          ).trim(),
          pendidikan_nama_sekolah_mcu: String(
            row[columnMapping["Nama Sekolah/Universitas"]] || ""
          ).trim(),
          pendidikan_jurusan_mcu: String(
            row[columnMapping["Jurusan"]] || ""
          ).trim(),

          // ✅ Data pengalaman kerja dengan suffix _mcu (sesuai PHP)
          pengalaman_kerja_perusahaan_1_mcu: String(
            row[columnMapping["Nama Perusahaan 1"]] || ""
          ).trim(),
          pengalaman_kerja_perusahaan_2_mcu: String(
            row[columnMapping["Nama perusahaan 2"]] || ""
          ).trim(),
          pengalaman_kerja_perusahaan_3_mcu: String(
            row[columnMapping["Nama perusahaan 3"]] || ""
          ).trim(),

          pengalaman_kerja_jabatan_1_mcu: String(
            row[columnMapping["Jabatan perusahaan 1"]] || ""
          ).trim(),
          pengalaman_kerja_jabatan_2_mcu: String(
            row[columnMapping["Jabatan perusahaan 2"]] || ""
          ).trim(),
          pengalaman_kerja_jabatan_3_mcu: String(
            row[columnMapping["Jabatan perusahaan 3"]] || ""
          ).trim(),

          pengalaman_kerja_tanggal_mulai_1_mcu: tanggalMulaiKerja1,
          pengalaman_kerja_tanggal_mulai_2_mcu: tanggalMulaiKerja2,
          pengalaman_kerja_tanggal_mulai_3_mcu: tanggalMulaiKerja3,
          pengalaman_kerja_tanggal_mulai_4_mcu: tanggalMulaiKerja4,

          pengalaman_kerja_tanggal_selesai_1_mcu: tanggalSelesaiKerja1,
          pengalaman_kerja_tanggal_selesai_2_mcu: tanggalSelesaiKerja2,
          pengalaman_kerja_tanggal_selesai_3_mcu: tanggalSelesaiKerja3,
          pengalaman_kerja_tanggal_selesai_4_mcu: tanggalSelesaiKerja4,

          pengalaman_kerja_kota_1_mcu: String(
            row[columnMapping["Kota perusahaan 1"]] || ""
          ).trim(),
          pengalaman_kerja_kota_2_mcu: String(
            row[columnMapping["Kota perusahaan 2"]] || ""
          ).trim(),
          pengalaman_kerja_kota_3_mcu: String(
            row[columnMapping["Kota perusahaan 3"]] || ""
          ).trim(),

          // ✅ Data keluarga
          orang_tua_nama_ayah_mcu: String(
            row[columnMapping["Nama Ayah Kandung"]] || ""
          ).trim(),
          orang_tua_tempat_lahir_ayah_mcu: String(
            row[columnMapping["Tempat lahir ayah"]] || ""
          ).trim(),
          orang_tua_tanggal_lahir_ayah_mcu: tanggalLahirAyah,
          orang_tua_nama_ibu_mcu: String(
            row[columnMapping["Nama Ibu Kandung"]] || ""
          ).trim(),
          orang_tua_tempat_lahir_ibu_mcu: String(
            row[columnMapping["Tempat lahir ibu"]] || ""
          ).trim(),
          orang_tua_tanggal_lahir_ibu_mcu: tanggalLahirIbu,

          rowNumber,
        };

        validData.push(mcuData);
      } catch (error) {
        errors.push({
          row: rowNumber,
          message: `Error parsing data: ${error.message}`,
        });
      }
    }

    return { validData, errors };
  };

  // ✅ TAMBAH: Helper function untuk format tanggal Excel
  formatExcelDate = (excelDate) => {
    if (!excelDate) return "";

    try {
      // ✅ Jika sudah dalam format tanggal
      if (excelDate instanceof Date) {
        return excelDate.toISOString().split("T")[0]; // YYYY-MM-DD
      }

      // ✅ Jika berupa serial number Excel
      if (typeof excelDate === "number") {
        const excelEpoch = new Date(1900, 0, 1);
        const daysSinceEpoch = excelDate - 2; // Excel bug: treats 1900 as leap year
        const jsDate = new Date(
          excelEpoch.getTime() + daysSinceEpoch * 24 * 60 * 60 * 1000
        );
        return jsDate.toISOString().split("T")[0];
      }

      // ✅ Jika berupa string tanggal
      if (typeof excelDate === "string") {
        const date = new Date(excelDate);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split("T")[0];
        }
      }

      return "";
    } catch (error) {
      console.warn("Error formatting Excel date:", excelDate, error);
      return "";
    }
  };

  // ✅ TAMBAH: Function untuk import data ke Firebase
  importFromExcel = async () => {
    const { importPreview } = this.state;

    if (importPreview.length === 0) {
      Swal.fire({
        title: "Tidak Ada Data MCU!",
        text: "Tidak ada data MCU valid untuk diimport",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    // ✅ Konfirmasi import
    const result = await Swal.fire({
      title: "Konfirmasi Import MCU",
      text: `Akan mengimport ${importPreview.length} data MCU karyawan. Lanjutkan?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Import MCU!",
      cancelButtonText: "Batal",
    });

    if (!result.isConfirmed) {
      return;
    }

    this.setState({ isImporting: true });

    try {
      const username_admin = JSON.parse(localStorage.getItem("login"))[0]
        .username;
      let successCount = 0;
      let updatedCount = 0;
      let errorCount = 0;

      console.log(
        "📊 Starting MCU data import. Total items:",
        importPreview.length
      );

      // ✅ Process dalam batch untuk performa better
      const batchSize = 10;
      for (let i = 0; i < importPreview.length; i += batchSize) {
        const batch = importPreview.slice(i, i + batchSize);

        // Use local counters for each batch
        let batchSuccessCount = 0;
        let batchUpdatedCount = 0;
        let batchErrorCount = 0;

        const batchPromises = batch.map(async (item) => {
          try {
            const collection = firebase.firestore().collection("employees");

            // Cegah duplikat: cari dulu by nomor_ktp_mcu, lalu by NIK.
            let existingDoc = null;

            if (item.nomor_ktp_mcu) {
              const byMcu = await collection
                .where("nomor_ktp_mcu", "==", item.nomor_ktp_mcu)
                .get();
              if (!byMcu.empty) {
                existingDoc = pickLatestEmployeeDoc(byMcu.docs);
              }
            }

            if (!existingDoc && item.nik) {
              const resolved = await resolveEmployeeDoc(collection, {
                nik: item.nik,
                tanggalLahir: item.tanggal_lahir || null,
              });
              if (resolved.doc) {
                existingDoc = resolved.doc;
              }
            }

            // ✅ Prepare data untuk Firebase sesuai dengan PHP version
            const firebaseData = {
              // ✅ Base data untuk login (sesuai PHP: nik, tanggal_lahir, status_karyawan)
              nik: item.nik,
              tanggal_lahir: item.tanggal_lahir,
              status_karyawan: item.status_karyawan,
              username_admin: username_admin,

              // ✅ Semua data MCU dengan suffix _mcu (sesuai PHP)
              jenis_kelamin_mcu: item.jenis_kelamin_mcu,
              nomor_ktp_mcu: item.nomor_ktp_mcu,
              nama_lengkap_mcu: item.nama_lengkap_mcu,
              tempat_lahir_mcu: item.tempat_lahir_mcu,
              tanggal_lahir_mcu: item.tanggal_lahir_mcu,
              alamat_ktp_mcu: item.alamat_ktp_mcu,
              alamat_domisili_mcu: item.alamat_domisili_mcu,
              nomor_hp_mcu: item.nomor_hp_mcu,
              email_mcu: item.email_mcu,
              agama_mcu: item.agama_mcu,
              nomor_rekening_bank_mcu: item.nomor_rekening_bank_mcu,

              // ✅ Data BPJS
              nomor_kartu_bpjs_kesehatan_mcu:
                item.nomor_kartu_bpjs_kesehatan_mcu,
              nomor_kartu_bpjs_ketenagakerjaan_mcu:
                item.nomor_kartu_bpjs_ketenagakerjaan_mcu,

              // ✅ Data kontak darurat
              kontak_darurat_nama_mcu: item.kontak_darurat_nama_mcu,
              kontak_darurat_hubungan_mcu: item.kontak_darurat_hubungan_mcu,
              kontak_darurat_no_telepon_mcu: item.kontak_darurat_no_telepon_mcu,

              // ✅ Data pendidikan
              pendidikan_terakhir_mcu: item.pendidikan_terakhir_mcu,
              pendidikan_nama_sekolah_mcu: item.pendidikan_nama_sekolah_mcu,
              pendidikan_jurusan_mcu: item.pendidikan_jurusan_mcu,

              // ✅ Data pengalaman kerja
              pengalaman_kerja_perusahaan_1_mcu:
                item.pengalaman_kerja_perusahaan_1_mcu,
              pengalaman_kerja_perusahaan_2_mcu:
                item.pengalaman_kerja_perusahaan_2_mcu,
              pengalaman_kerja_perusahaan_3_mcu:
                item.pengalaman_kerja_perusahaan_3_mcu,

              pengalaman_kerja_jabatan_1_mcu:
                item.pengalaman_kerja_jabatan_1_mcu,
              pengalaman_kerja_jabatan_2_mcu:
                item.pengalaman_kerja_jabatan_2_mcu,
              pengalaman_kerja_jabatan_3_mcu:
                item.pengalaman_kerja_jabatan_3_mcu,

              pengalaman_kerja_tanggal_mulai_1_mcu:
                item.pengalaman_kerja_tanggal_mulai_1_mcu,
              pengalaman_kerja_tanggal_mulai_2_mcu:
                item.pengalaman_kerja_tanggal_mulai_2_mcu,
              pengalaman_kerja_tanggal_mulai_3_mcu:
                item.pengalaman_kerja_tanggal_mulai_3_mcu,

              pengalaman_kerja_tanggal_selesai_1_mcu:
                item.pengalaman_kerja_tanggal_selesai_1_mcu,
              pengalaman_kerja_tanggal_selesai_2_mcu:
                item.pengalaman_kerja_tanggal_selesai_2_mcu,
              pengalaman_kerja_tanggal_selesai_3_mcu:
                item.pengalaman_kerja_tanggal_selesai_3_mcu,

              pengalaman_kerja_kota_1_mcu: item.pengalaman_kerja_kota_1_mcu,
              pengalaman_kerja_kota_2_mcu: item.pengalaman_kerja_kota_2_mcu,
              pengalaman_kerja_kota_3_mcu: item.pengalaman_kerja_kota_3_mcu,

              // ✅ Data keluarga
              orang_tua_nama_ayah_mcu: item.orang_tua_nama_ayah_mcu,
              orang_tua_tempat_lahir_ayah_mcu:
                item.orang_tua_tempat_lahir_ayah_mcu,
              orang_tua_tanggal_lahir_ayah_mcu:
                item.orang_tua_tanggal_lahir_ayah_mcu,
              orang_tua_nama_ibu_mcu: item.orang_tua_nama_ibu_mcu,
              orang_tua_tempat_lahir_ibu_mcu:
                item.orang_tua_tempat_lahir_ibu_mcu,
              orang_tua_tanggal_lahir_ibu_mcu:
                item.orang_tua_tanggal_lahir_ibu_mcu,

              // ✅ Default empty URLs (sesuai PHP)
              foto_url: "",
              ktp_url: "",
              npwp_url: "",
              kk_url: "",
              cv_url: "",
              sertifikasi_training_1_url: "",
              sertifikasi_training_2_url: "",
              sertifikasi_training_3_url: "",
              sertifikasi_training_4_url: "",
              rekening_bank_url: "",
              mutasi_rekening_url: "",
              ijasah_url: "",
              transkrip_url: "",
              skck_url: "",
              bpjs_kesehatan_url: "",
              bpjs_ketenagakerjaan_url: "",
              keterangan_kesehatan_url: "",
              surat_pernyataan_kesanggupan_bpjs_url: "",
              keterangan_bpjs_tidak_aktif_url: "",
              peserta_jkn_url: "",
              iuran_jkn_url: "",
              vaksinasi_1_url: "",
              vaksinasi_2_url: "",
              vaksinasi_3_url: "",
              pemadanan_npwp_url: "",
              surat_lamaran_url: "",
              formulir_lamaran_pekerjaan_url: "",
              formulir_okb_url: "",

              form_1_submitted: "belum",
              form_1_submitted_date: "",
              form_2_submitted: "belum",
              form_2_submitted_date: "",
              form_3_submitted: "belum",
              form_3_submitted_date: "",
              status: "dibuat",
              created_at: new Date(),
              is_reviewed_by_hr: "0",
              is_excel_downloaded: "0",
            };

            if (existingDoc) {
              // Update MCU fields saja — jangan overwrite URL/form status yang sudah ada
              const omitOnUpdate = new Set([
                "foto_url",
                "ktp_url",
                "npwp_url",
                "kk_url",
                "cv_url",
                "sertifikasi_training_1_url",
                "sertifikasi_training_2_url",
                "sertifikasi_training_3_url",
                "sertifikasi_training_4_url",
                "rekening_bank_url",
                "mutasi_rekening_url",
                "ijasah_url",
                "transkrip_url",
                "skck_url",
                "bpjs_kesehatan_url",
                "bpjs_ketenagakerjaan_url",
                "keterangan_kesehatan_url",
                "surat_pernyataan_kesanggupan_bpjs_url",
                "keterangan_bpjs_tidak_aktif_url",
                "peserta_jkn_url",
                "iuran_jkn_url",
                "vaksinasi_1_url",
                "vaksinasi_2_url",
                "vaksinasi_3_url",
                "pemadanan_npwp_url",
                "surat_lamaran_url",
                "formulir_lamaran_pekerjaan_url",
                "formulir_okb_url",
                "form_1_submitted",
                "form_1_submitted_date",
                "form_2_submitted",
                "form_2_submitted_date",
                "form_3_submitted",
                "form_3_submitted_date",
                "status",
                "created_at",
                "is_reviewed_by_hr",
                "is_excel_downloaded",
              ]);
              const mcuUpdateFields = {};
              Object.keys(firebaseData).forEach((key) => {
                if (!omitOnUpdate.has(key)) {
                  mcuUpdateFields[key] = firebaseData[key];
                }
              });

              await existingDoc.ref.update({
                ...mcuUpdateFields,
                updated_at: new Date(),
                last_updated_by: username_admin,
              });

              batchUpdatedCount++;
              console.log(
                `🔄 Updated MCU: ${item.nomor_ktp_mcu || item.nik}, Document ID: ${existingDoc.id}`
              );
            } else {
              // ✅ Buat dokumen baru hanya jika benar-benar belum ada
              const docRef = await collection.add(firebaseData);

              batchSuccessCount++;
              console.log(
                `✅ Created MCU: ${item.nomor_ktp_mcu || item.nik}, Document ID: ${docRef.id}`
              );
            }
          } catch (error) {
            batchErrorCount++;
            console.error(
              `❌ Error importing MCU ${item.nomor_ktp_mcu || item.nik}:`,
              error
            );
          }
        });

        await Promise.all(batchPromises);

        // Update main counters after batch
        successCount += batchSuccessCount;
        updatedCount += batchUpdatedCount;
        errorCount += batchErrorCount;

        // ✅ Progress update
        const progress = Math.round(
          ((i + batchSize) / importPreview.length) * 100
        );
        console.log(`📊 MCU Import progress: ${progress}%`);
      }

      // ✅ Reset state
      this.setState({
        isImporting: false,
        selectedFile: "",
        importPreview: [],
        showPreview: false,
      });

      // Muat ulang daftar (karena tidak pakai onSnapshot realtime)
      this.loadEmployees();

      // ✅ Clear file input
      const fileInput = document.getElementById("mcu-file-input");
      if (fileInput) {
        fileInput.value = "";
      }

      // ✅ Summary log (sesuai PHP)
      console.log("📈 MCU Upload Summary:", {
        processing_results: {
          total_rows_processed: importPreview.length,
          processed_successfully: successCount,
          updated_existing: updatedCount,
          failed_with_errors: errorCount,
          success_rate_percentage:
            importPreview.length > 0
              ? Math.round(
                  ((successCount + updatedCount) / importPreview.length) * 100
                )
              : 0,
        },
        firebase_operations: {
          collection_name: "employees",
          operation_type: "bulk_insert_or_update",
          source: "mcu_upload",
        },
      });

      // ✅ Show result
      Swal.fire({
        title: "Import MCU Selesai!",
        html: `
        <div style="text-align: left;">
          <p><strong>✅ Data MCU Baru:</strong> ${successCount} data</p>
          <p><strong>🔄 Data MCU Updated:</strong> ${updatedCount} data</p>
          <p><strong>❌ Gagal:</strong> ${errorCount} data</p>
          <p><strong>📊 Total Diproses:</strong> ${
            successCount + updatedCount
          } data</p>
          <p><strong>📈 Success Rate:</strong> ${
            importPreview.length > 0
              ? Math.round(
                  ((successCount + updatedCount) / importPreview.length) * 100
                )
              : 0
          }%</p>
        </div>
      `,
        icon: successCount + updatedCount > 0 ? "success" : "error",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("❌ MCU Import error:", error);

      this.setState({ isImporting: false });

      Swal.fire({
        title: "Error Import MCU!",
        text: "Terjadi kesalahan saat import data MCU",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  downloadExcel = () => {
    // console.log('Download Excel');
    let employeesAll = [
      [
        // ✅ HEADER sesuai dengan PHP mapping
        "id",
        "nik",
        "nomor_ktp",
        "nomor_kk",
        "nomor_npwp",
        "tempat_lahir",
        "tanggal_lahir",
        "tanggal_lahir_formatted",
        "tanggal_masuk",

        // Data pribadi
        "nama_lengkap",
        "jenis_kelamin",
        "golongan_darah",
        "agama",
        "nomor_hp",
        "nomor_rekening_bank",

        // Kontak diri
        "email",
        "facebook",
        "twitter",
        "linkedin",
        "instagram",

        // BPJS
        "nomor_kartu_bpjs_kesehatan",
        "nomor_kartu_bpjs_ketenagakerjaan",
        "keterangan_kartu_bpjs_kesehatan",
        "keterangan_kartu_bpjs_ketenagakerjaan",

        // Alamat
        "province",
        "regency",
        "district",
        "village",
        "addressDetail",
        "alamat_sekarang_provinsi",
        "alamat_sekarang_kota",
        "alamat_sekarang_kecamatan",
        "alamat_sekarang_desa",
        "alamat_sekarang_alamat",

        // Data kontak darurat
        "kontak_darurat_nama",
        "kontak_darurat_hubungan",
        "kontak_darurat_hubungan_kerabat",
        "kontak_darurat_no_telepon",

        // Data pendidikan
        "pendidikan_terakhir",
        "pendidikan_nama_sekolah",
        "pendidikan_jurusan",
        "pendidikan_kursus",

        // Data diri lanjutan
        "status_perdata",
        "nama_pasangan",
        "tempat_pernikahan",
        "tanggal_pernikahan",
        "tempat_lahir_pasangan",
        "tanggal_lahir_pasangan",
        "pekerjaan_pasangan",
        "tempat_pasangan_bekerja",

        // Data keluarga
        "orang_tua_nama_ayah",
        "orang_tua_tempat_lahir_ayah",
        "orang_tua_tanggal_lahir_ayah",
        "orang_tua_nama_ibu",
        "orang_tua_tempat_lahir_ibu",
        "orang_tua_tanggal_lahir_ibu",

        // Anak
        "anak_anak_nama_1",
        "anak_anak_jenis_kelamin_1",
        "anak_anak_tempat_lahir_1",
        "anak_anak_tanggal_lahir_1",
        "anak_anak_nama_2",
        "anak_anak_jenis_kelamin_2",
        "anak_anak_tempat_lahir_2",
        "anak_anak_tanggal_lahir_2",
        "anak_anak_nama_3",
        "anak_anak_jenis_kelamin_3",
        "anak_anak_tempat_lahir_3",
        "anak_anak_tanggal_lahir_3",
        "anak_anak_nama_4",
        "anak_anak_jenis_kelamin_4",
        "anak_anak_tempat_lahir_4",
        "anak_anak_tanggal_lahir_4",

        // Saudara
        "saudara_kandung_nama_1",
        "saudara_kandung_jenis_kelamin_1",
        "saudara_kandung_tempat_lahir_1",
        "saudara_kandung_tanggal_lahir_1",
        "saudara_kandung_nama_2",
        "saudara_kandung_jenis_kelamin_2",
        "saudara_kandung_tempat_lahir_2",
        "saudara_kandung_tanggal_lahir_2",
        "saudara_kandung_nama_3",
        "saudara_kandung_jenis_kelamin_3",
        "saudara_kandung_tempat_lahir_3",
        "saudara_kandung_tanggal_lahir_3",
        "saudara_kandung_nama_4",
        "saudara_kandung_jenis_kelamin_4",
        "saudara_kandung_tempat_lahir_4",
        "saudara_kandung_tanggal_lahir_4",

        // Mertua
        "mertua_nama_ayah",
        "mertua_tempat_lahir_ayah",
        "mertua_tanggal_lahir_ayah",
        "mertua_nama_ibu",
        "mertua_tempat_lahir_ibu",
        "mertua_tanggal_lahir_ibu",

        // Data pengalaman kerja
        "pengalaman_kerja_perusahaan_1",
        "pengalaman_kerja_jabatan_1",
        "pengalaman_kerja_tanggal_mulai_1",
        "pengalaman_kerja_tanggal_selesai_1",
        "pengalaman_kerja_kota_1",
        "pengalaman_kerja_perusahaan_2",
        "pengalaman_kerja_jabatan_2",
        "pengalaman_kerja_tanggal_mulai_2",
        "pengalaman_kerja_tanggal_selesai_2",
        "pengalaman_kerja_kota_2",
        "pengalaman_kerja_perusahaan_3",
        "pengalaman_kerja_jabatan_3",
        "pengalaman_kerja_tanggal_mulai_3",
        "pengalaman_kerja_tanggal_selesai_3",
        "pengalaman_kerja_kota_3",

        // Sertifikasi training
        "nama_sertifikasi_1",
        "nama_sertifikasi_2",
        "nama_sertifikasi_3",
        "nama_sertifikasi_4",
        "lembaga_pemberi_1",
        "lembaga_pemberi_2",
        "lembaga_pemberi_3",
        "lembaga_pemberi_4",

        // Data vaksinasi
        "jenis_vaksin",
        "tanggal_vaksin_1",
        "lokasi_vaksin_1",
        "tanggal_vaksin_2",
        "lokasi_vaksin_2",
        "tanggal_vaksin_3",
        "lokasi_vaksin_3",

        // Data form tambahan
        "tanggal_berlaku_skck",
        "bpjs_status",
        "tanggal_pembuatan_surat_keterangan_sehat",
        "status_iuran",

        // URL berkas gambar
        "foto_url",
        "ktp_url",
        "npwp_url",
        "kk_url",
        "cv_url",
        "sertifikasi_training_1_url",
        "sertifikasi_training_2_url",
        "sertifikasi_training_3_url",
        "sertifikasi_training_4_url",
        "rekening_bank_url",
        "mutasi_rekening_url",
        "ijasah_url",
        "transkrip_url",
        "skck_url",
        "bpjs_kesehatan_url",
        "bpjs_ketenagakerjaan_url",
        "keterangan_kesehatan_url",
        "keterangan_bpjs_tidak_aktif_url",
        "surat_pernyataan_kesanggupan_bpjs_url", // <-- added
        "peserta_jkn_url",
        "iuran_jkn_url",
        "vaksinasi_1_url",
        "vaksinasi_2_url",
        "vaksinasi_3_url",
        "pemadanan_npwp_url",
        "surat_lamaran_url",
        "formulir_lamaran_pekerjaan_url",
        "formulir_okb_url",
        "foto_validate_by_ocr",
        "ktp_validate_by_ocr",
        "npwp_validate_by_ocr",
        "kk_validate_by_ocr",
        "cv_validate_by_ocr",
        "rekening_bank_validate_by_ocr",
        "mutasi_rekening_validate_by_ocr",
        "ijasah_validate_by_ocr",
        "transkrip_validate_by_ocr",
        "skck_validate_by_ocr",
        "bpjs_kesehatan_validate_by_ocr",
        "bpjs_ketenagakerjaan_validate_by_ocr",
        "keterangan_kesehatan_validate_by_ocr",
        "peserta_jkn_validate_by_ocr",
        "iuran_jkn_validate_by_ocr",
        "vaksinasi_1_validate_by_ocr",
        "vaksinasi_2_validate_by_ocr",
        "vaksinasi_3_validate_by_ocr",
        "pemadanan_npwp_validate_by_ocr",
        "surat_lamaran_validate_by_ocr",
        "formulir_lamaran_pekerjaan_validate_by_ocr",
        "formulir_okb_validate_by_ocr",
        "surat_pernyataan_kesanggupan_bpjs_validate_by_ocr",

        // Data metadata
        "status_karyawan",
        "status",
        "form_1_submitted",
        "form_1_submitted_date",
        "form_2_submitted",
        "form_2_submitted_date",
        "form_3_submitted",
        "form_3_submitted_date",
        "created_at",
        "username_admin",
      ],
    ];

    let downloadCount = 0;
    let skippedCount = 0;

    // ✅ Filter berdasarkan downloadFilter state dan filter lainnya
    const {
      downloadFilter,
      tanggalMasukFrom,
      tanggalMasukTo,
      formSubmissionFilter,
    } = this.state;

    this.state.employeesAll.forEach((employee, index) => {
      // ✅ Filter berdasarkan is_excel_downloaded sesuai dengan downloadFilter
      let matchesDownloadFilter = false;
      if (downloadFilter === "belum") {
        matchesDownloadFilter = employee.is_excel_downloaded === "0";
      } else if (downloadFilter === "sudah") {
        matchesDownloadFilter = employee.is_excel_downloaded === "1";
      } else {
        // "semua"
        matchesDownloadFilter = true;
      }

      // ✅ Filter berdasarkan tanggal masuk
      let matchesTanggalMasuk = true;
      if (tanggalMasukFrom) {
        const fromDate = new Date(tanggalMasukFrom);
        const employeeDate = employee.tanggal_masuk
          ? new Date(employee.tanggal_masuk)
          : null;
        if (!employeeDate || employeeDate < fromDate) {
          matchesTanggalMasuk = false;
        }
      }
      if (tanggalMasukTo) {
        const toDate = new Date(tanggalMasukTo);
        toDate.setHours(23, 59, 59, 999); // Set ke akhir hari
        const employeeDate = employee.tanggal_masuk
          ? new Date(employee.tanggal_masuk)
          : null;
        if (!employeeDate || employeeDate > toDate) {
          matchesTanggalMasuk = false;
        }
      }

      // ✅ Filter berdasarkan status pengisian form
      let matchesFormSubmission = true;
      if (formSubmissionFilter === "belum_isi") {
        matchesFormSubmission =
          employee.form_1_submitted === "belum" &&
          employee.form_2_submitted === "belum" &&
          employee.form_3_submitted === "belum";
      } else if (formSubmissionFilter === "form1_saja") {
        matchesFormSubmission =
          employee.form_1_submitted === "diisi" &&
          employee.form_2_submitted === "belum" &&
          employee.form_3_submitted === "belum";
      } else if (formSubmissionFilter === "form1_dan_2") {
        matchesFormSubmission =
          employee.form_1_submitted === "diisi" &&
          employee.form_2_submitted === "diisi" &&
          employee.form_3_submitted === "belum";
      } else if (formSubmissionFilter === "form1_2_dan_3") {
        matchesFormSubmission =
          employee.form_1_submitted === "diisi" &&
          employee.form_2_submitted === "diisi" &&
          employee.form_3_submitted === "diisi";
      }
      // "semua" tidak perlu filter, matchesFormSubmission tetap true

      // ✅ KONDISI: semua filter terpenuhi (tanpa memaksa form_1_submitted harus "diisi")
      const meetsAllCriteria =
        matchesDownloadFilter && matchesTanggalMasuk && matchesFormSubmission;

      console.log(`📋 Checking employee ${index + 1}:`, {
        nik: employee.nik,
        nama_lengkap: employee.nama_lengkap,
        form_1_submitted: employee.form_1_submitted,
        is_excel_downloaded: employee.is_excel_downloaded,
        tanggal_masuk: employee.tanggal_masuk,
        downloadFilter: downloadFilter,
        matchesDownloadFilter: matchesDownloadFilter,
        matchesTanggalMasuk: matchesTanggalMasuk,
        matchesFormSubmission: matchesFormSubmission,
        meets_criteria: meetsAllCriteria,
      });

      if (meetsAllCriteria) {
        console.log(`✅ Including employee in Excel: ${employee.nama_lengkap}`);

        let employeeArray = [
          // ✅ DATA VALUES sesuai dengan PHP mapping
          employee.key || "", // id
          "", // nik (kosong sesuai PHP)
          employee.nik || "", // nomor_ktp (mapped dari nik)
          employee.nomor_kk || "",
          employee.nomor_npwp || "",
          employee.tempat_lahir || "",
          employee.tanggal_lahir || "",
          employee.tanggal_lahir_formatted || "",
          employee.tanggal_masuk || "",

          // Data pribadi
          employee.nama_lengkap || "",
          employee.jenis_kelamin || "",
          employee.golongan_darah || "",
          employee.agama || "",
          employee.nomor_hp || "",
          employee.nomor_rekening_bank || "",

          // Kontak diri (mapping dari sosmed_*)
          employee.email || "", // sosmed_email
          employee.sosmed_facebook || "",
          employee.sosmed_twitter || "",
          employee.sosmed_linkedin || "",
          employee.sosmed_instagram || "",

          // BPJS
          employee.nomor_kartu_bpjs_kesehatan || "",
          employee.nomor_kartu_bpjs_ketenagakerjaan || "",
          employee.keterangan_kartu_bpjs_kesehatan || "",
          employee.keterangan_kartu_bpjs_ketenagakerjaan || "",

          // Alamat
          employee.province || "",
          employee.regency || "",
          employee.district || "",
          employee.village || "",
          employee.addressDetail || "",
          employee.ASprovince || "", // alamat_sekarang_provinsi
          employee.ASregency || "", // alamat_sekarang_kota
          employee.ASdistrict || "", // alamat_sekarang_kecamatan
          employee.ASvillage || "", // alamat_sekarang_desa
          employee.ASaddressDetail || "", // alamat_sekarang_alamat

          // Data kontak darurat
          employee.kontak_darurat_nama || "",
          employee.kontak_darurat_hubungan || "",
          employee.kontak_darurat_hubungan_kerabat || "",
          employee.kontak_darurat_no_telepon || "",

          // Data pendidikan
          employee.pendidikan_terakhir || "",
          employee.pendidikan_nama_sekolah || "",
          employee.pendidikan_jurusan || "",
          employee.pendidikan_kursus || "",

          // Data diri lanjutan
          employee.status_perdata || "",
          employee.nama_pasangan || "",
          employee.tempat_pernikahan || "",
          employee.tanggal_pernikahan || "",
          employee.tempat_lahir_pasangan || "",
          employee.tanggal_lahir_pasangan || "",
          employee.pekerjaan_pasangan || "",
          employee.tempat_pasangan_bekerja || "",

          // Data keluarga
          employee.orang_tua_nama_ayah || "",
          employee.orang_tua_tempat_lahir_ayah || "",
          employee.orang_tua_tanggal_lahir_ayah || "",
          employee.orang_tua_nama_ibu || "",
          employee.orang_tua_tempat_lahir_ibu || "",
          employee.orang_tua_tanggal_lahir_ibu || "",

          // Anak
          employee.anak_anak_nama_1 || "",
          employee.anak_anak_jenis_kelamin_1 || "",
          employee.anak_anak_tempat_lahir_1 || "",
          employee.anak_anak_tanggal_lahir_1 || "",
          employee.anak_anak_nama_2 || "",
          employee.anak_anak_jenis_kelamin_2 || "",
          employee.anak_anak_tempat_lahir_2 || "",
          employee.anak_anak_tanggal_lahir_2 || "",
          employee.anak_anak_nama_3 || "",
          employee.anak_anak_jenis_kelamin_3 || "",
          employee.anak_anak_tempat_lahir_3 || "",
          employee.anak_anak_tanggal_lahir_3 || "",
          employee.anak_anak_nama_4 || "",
          employee.anak_anak_jenis_kelamin_4 || "",
          employee.anak_anak_tempat_lahir_4 || "",
          employee.anak_anak_tanggal_lahir_4 || "",

          // Saudara
          employee.saudara_kandung_nama_1 || "",
          employee.saudara_kandung_jenis_kelamin_1 || "",
          employee.saudara_kandung_tempat_lahir_1 || "",
          employee.saudara_kandung_tanggal_lahir_1 || "",
          employee.saudara_kandung_nama_2 || "",
          employee.saudara_kandung_jenis_kelamin_2 || "",
          employee.saudara_kandung_tempat_lahir_2 || "",
          employee.saudara_kandung_tanggal_lahir_2 || "",
          employee.saudara_kandung_nama_3 || "",
          employee.saudara_kandung_jenis_kelamin_3 || "",
          employee.saudara_kandung_tempat_lahir_3 || "",
          employee.saudara_kandung_tanggal_lahir_3 || "",
          employee.saudara_kandung_nama_4 || "",
          employee.saudara_kandung_jenis_kelamin_4 || "",
          employee.saudara_kandung_tempat_lahir_4 || "",
          employee.saudara_kandung_tanggal_lahir_4 || "",

          // Mertua
          employee.mertua_nama_ayah || "",
          employee.mertua_tempat_lahir_ayah || "",
          employee.mertua_tanggal_lahir_ayah || "",
          employee.mertua_nama_ibu || "",
          employee.mertua_tempat_lahir_ibu || "",
          employee.mertua_tanggal_lahir_ibu || "",

          // Data pengalaman kerja
          employee.pengalaman_kerja_perusahaan_1 || "",
          employee.pengalaman_kerja_jabatan_1 || "",
          employee.pengalaman_kerja_tanggal_mulai_1 || "",
          employee.pengalaman_kerja_tanggal_selesai_1 || "",
          employee.pengalaman_kerja_kota_1 || "",
          employee.pengalaman_kerja_perusahaan_2 || "",
          employee.pengalaman_kerja_jabatan_2 || "",
          employee.pengalaman_kerja_tanggal_mulai_2 || "",
          employee.pengalaman_kerja_tanggal_selesai_2 || "",
          employee.pengalaman_kerja_kota_2 || "",
          employee.pengalaman_kerja_perusahaan_3 || "",
          employee.pengalaman_kerja_jabatan_3 || "",
          employee.pengalaman_kerja_tanggal_mulai_3 || "",
          employee.pengalaman_kerja_tanggal_selesai_3 || "",
          employee.pengalaman_kerja_kota_3 || "",

          // Sertifikasi training
          employee.nama_sertifikasi_1 || "",
          employee.nama_sertifikasi_2 || "",
          employee.nama_sertifikasi_3 || "",
          employee.nama_sertifikasi_4 || "",
          employee.lembaga_pemberi_1 || "",
          employee.lembaga_pemberi_2 || "",
          employee.lembaga_pemberi_3 || "",
          employee.lembaga_pemberi_4 || "",

          // Data vaksinasi
          employee.jenis_vaksin || "",
          employee.tanggal_vaksin_1 || "",
          employee.lokasi_vaksin_1 || "",
          employee.tanggal_vaksin_2 || "",
          employee.lokasi_vaksin_2 || "",
          employee.tanggal_vaksin_3 || "",
          employee.lokasi_vaksin_3 || "",

          // Data form tambahan
          employee.tanggal_berlaku_skck || "", // ✅ Note: mapping dari skck ke skck
          employee.bpjs_status || "",
          employee.tanggal_pembuatan_surat_keterangan_sehat || "",
          employee.status_iuran || "",

          // URL berkas gambar
          employee.foto_url || "",
          employee.ktp_url || "",
          employee.npwp_url || "",
          employee.kk_url || "",
          employee.cv_url || "",
          employee.sertifikasi_training_1_url || "",
          employee.sertifikasi_training_2_url || "",
          employee.sertifikasi_training_3_url || "",
          employee.sertifikasi_training_4_url || "",
          employee.rekening_bank_url || "",
          employee.mutasi_rekening_url || "",
          employee.ijasah_url || "",
          employee.transkrip_url || "",
          employee.skck_url || "",
          employee.bpjs_kesehatan_url || "",
          employee.bpjs_ketenagakerjaan_url || "",
          employee.keterangan_kesehatan_url || "",
          employee.keterangan_bpjs_tidak_aktif_url || "",
          employee.surat_pernyataan_kesanggupan_bpjs_url || "", // <-- added
          employee.peserta_jkn_url || "",
          employee.iuran_jkn_url || "",
          employee.vaksinasi_1_url || "",
          employee.vaksinasi_2_url || "",
          employee.vaksinasi_3_url || "",
          employee.pemadanan_npwp_url || "",
          employee.surat_lamaran_url || "",
          employee.formulir_lamaran_pekerjaan_url || "",
          employee.formulir_okb_url || "",
          employee.foto_validate_by_ocr === true,
          employee.ktp_validate_by_ocr === true,
          employee.npwp_validate_by_ocr === true,
          employee.kk_validate_by_ocr === true,
          employee.cv_validate_by_ocr === true,
          employee.rekening_bank_validate_by_ocr === true,
          employee.mutasi_rekening_validate_by_ocr === true,
          employee.ijasah_validate_by_ocr === true,
          employee.transkrip_validate_by_ocr === true,
          employee.skck_validate_by_ocr === true,
          employee.bpjs_kesehatan_validate_by_ocr === true,
          employee.bpjs_ketenagakerjaan_validate_by_ocr === true,
          employee.keterangan_kesehatan_validate_by_ocr === true,
          employee.peserta_jkn_validate_by_ocr === true,
          employee.iuran_jkn_validate_by_ocr === true,
          employee.vaksinasi_1_validate_by_ocr === true,
          employee.vaksinasi_2_validate_by_ocr === true,
          employee.vaksinasi_3_validate_by_ocr === true,
          employee.pemadanan_npwp_validate_by_ocr === true,
          employee.surat_lamaran_validate_by_ocr === true,
          employee.formulir_lamaran_pekerjaan_validate_by_ocr === true,
          employee.formulir_okb_validate_by_ocr === true,
          employee.surat_pernyataan_kesanggupan_bpjs_validate_by_ocr === true,

          // Data metadata
          employee.status_karyawan || "",
          employee.status || "",
          employee.form_1_submitted || "",
          employee.form_1_submitted_date || "",
          employee.form_2_submitted || "",
          employee.form_2_submitted_date || "",
          employee.form_3_submitted || "",
          employee.form_3_submitted_date || "",
          employee.created_at || "",
          employee.username_admin || "",
        ];

        employeesAll.push(employeeArray);
        downloadCount++;

        // ✅ Update status is_excel_downloaded dari "0" ke "1" hanya jika belum didownload
        // Jika filter "sudah", tidak perlu update karena sudah "1"
        if (employee.is_excel_downloaded === "0") {
          this.removeDownloadedCandidate(employee.key);
        }
      } else {
        skippedCount++;
        let reason = "";
        if (!matchesDownloadFilter) {
          reason = `Does not match download filter: ${downloadFilter}`;
        } else if (!matchesTanggalMasuk) {
          reason = `Does not match tanggal masuk filter (${
            tanggalMasukFrom || ""
          } - ${tanggalMasukTo || ""})`;
        } else if (!matchesFormSubmission) {
          reason = `Does not match form submission filter: ${formSubmissionFilter}`;
        } else {
          reason = "Unknown reason";
        }
        console.log(`❌ Skipping employee: ${employee.nama_lengkap}`, {
          form_1_submitted: employee.form_1_submitted,
          is_excel_downloaded: employee.is_excel_downloaded,
          tanggal_masuk: employee.tanggal_masuk,
          downloadFilter: downloadFilter,
          tanggalMasukFrom: tanggalMasukFrom,
          tanggalMasukTo: tanggalMasukTo,
          formSubmissionFilter: formSubmissionFilter,
          reason: reason,
        });
      }
    });

    // ✅ Debug summary
    console.log(`📊 Download Summary:`, {
      total_employees: this.state.employeesAll.length,
      downloaded: downloadCount,
      skipped: skippedCount,
      excel_rows: employeesAll.length - 1, // minus header
      filters_applied: {
        downloadFilter: downloadFilter,
        tanggalMasukFrom: tanggalMasukFrom,
        tanggalMasukTo: tanggalMasukTo,
        formSubmissionFilter: formSubmissionFilter,
      },
    });

    // ✅ Generate Excel file hanya jika ada data yang memenuhi kriteria
    if (downloadCount > 0) {
      const date = Date.now();
      const wb = XLSX.utils.book_new();
      const wsAll = XLSX.utils.aoa_to_sheet(employeesAll);
      XLSX.utils.book_append_sheet(wb, wsAll, "Employees");
      XLSX.writeFile(wb, `employees_${date}.xlsx`);

      console.log(
        `✅ Excel downloaded successfully! ${downloadCount} employees included.`
      );

      // ✅ Show success notification
      const filterLabel =
        downloadFilter === "belum"
          ? "Belum Download"
          : downloadFilter === "sudah"
          ? "Telah Download"
          : "Semua";
      const formSubmissionLabel =
        formSubmissionFilter === "belum_isi"
          ? "Belum Isi Form"
          : formSubmissionFilter === "form1_saja"
          ? "Form 1 Saja"
          : formSubmissionFilter === "form1_dan_2"
          ? "Form 1 & 2"
          : formSubmissionFilter === "form1_2_dan_3"
          ? "Form 1, 2 & 3"
          : "Semua";
      Swal.fire({
        title: "Download Berhasil!",
        html: `
        <div style="text-align: left;">
          <p><strong>${downloadCount} data karyawan</strong> telah didownload ke Excel</p>
          <p><strong>Filter yang digunakan:</strong></p>
          <ul style="text-align: left;">
            <li>Status Download: ${filterLabel}</li>
            <li>Status Pengisian: ${formSubmissionLabel}</li>
            <li>Tanggal Masuk: ${tanggalMasukFrom || "Semua"} - ${
          tanggalMasukTo || "Semua"
        }</li>
          </ul>
        </div>
      `,
        icon: "success",
        timer: 3000,
        showConfirmButton: true,
      });
    } else {
      console.log("⚠️ No employees meet the download criteria");

      // ✅ Show warning if no data to download
      const filterLabel =
        downloadFilter === "belum"
          ? "Belum Download"
          : downloadFilter === "sudah"
          ? "Telah Download"
          : "Semua";
      const formSubmissionLabel =
        formSubmissionFilter === "belum_isi"
          ? "Belum Isi Form"
          : formSubmissionFilter === "form1_saja"
          ? "Form 1 Saja"
          : formSubmissionFilter === "form1_dan_2"
          ? "Form 1 & 2"
          : formSubmissionFilter === "form1_2_dan_3"
          ? "Form 1, 2 & 3"
          : "Semua";
      Swal.fire({
        title: "Tidak Ada Data!",
        html: `
        <div style="text-align: left;">
          <p><strong>Total Data:</strong> ${this.state.employeesAll.length}</p>
          <p><strong>Yang Memenuhi Kriteria:</strong> ${downloadCount}</p>
          <br>
          <p><strong>Filter Aktif:</strong></p>
          <ul style="text-align: left;">
            <li>Status Download: ${filterLabel}</li>
            <li>Status Pengisian: ${formSubmissionLabel}</li>
            <li>Tanggal Masuk: ${tanggalMasukFrom || "Semua"} - ${
          tanggalMasukTo || "Semua"
        }</li>
          </ul>
          <br>
          <p><strong>Kriteria Download:</strong></p>
          <ul style="text-align: left;">
            <li>✅ Form 1 sudah diisi</li>
            <li>✅ Sesuai dengan filter di atas</li>
          </ul>
          <br>
          <p>Silahkan pastikan ada karyawan yang memenuhi kriteria di atas.</p>
        </div>
      `,
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  removeDownloadedCandidate = (id) => {
    this.db
      .doc(id)
      .update({
        is_excel_downloaded: "1",
      })
      .then(() => {
        console.log("✅ Employee excel download status updated successfully!");
        console.log(`📊 Document ID: ${id} - is_excel_downloaded set to "1"`);
      })
      .catch((error) => {
        console.error("❌ Error updating excel download status:", error);
      });
  };

  delete = (id) => {
    if (window.confirm("Yakin mau hapus data ini?")) {
      this.db
        .doc(id)
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const username_admin =
      (JSON.parse(localStorage.getItem("login")) || [])[0]?.username || "";
    const validStatuses = [
      "staff",
      "nonstaff",
      "nonstaff helper",
      "pkl/magang",
    ];
    const lines = this.state.data_import
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    if (lines.length === 0) {
      Swal.fire({
        title: "Data kosong",
        text: "Silahkan isi data import terlebih dahulu.",
        icon: "warning",
      });
      return;
    }

    const payloads = [];
    const errors = [];

    lines.forEach((line, index) => {
      const rowNumber = index + 1;
      // Support paste dari Excel (TAB) dan juga spasi berurutan.
      const columns = line
        .split(/\t+|\s{2,}/)
        .map((col) => col.trim())
        .filter((col) => col !== "");

      if (columns.length < 3) {
        errors.push(
          `Baris ${rowNumber}: format harus "NIK<TAB>TGL_LAHIR<TAB>STATUS_KARYAWAN".`
        );
        return;
      }

      const nik = (columns[0] || "").replace(/\s+/g, "");
      const tanggal_lahir = (columns[1] || "").replace(/\s+/g, "");
      const status_karyawan = (columns[2] || "").toLowerCase();

      if (!/^\d{16}$/.test(nik)) {
        errors.push(`Baris ${rowNumber}: NIK harus 16 digit angka.`);
        return;
      }

      if (!/^\d{8}$/.test(tanggal_lahir)) {
        errors.push(
          `Baris ${rowNumber}: tanggal lahir harus format DDMMYYYY (contoh: 27042002).`
        );
        return;
      }

      if (!validStatuses.includes(status_karyawan)) {
        errors.push(
          `Baris ${rowNumber}: status karyawan harus salah satu dari ${validStatuses.join(
            ", "
          )}.`
        );
        return;
      }

      payloads.push({
        nik,
        tanggal_lahir,
        status_karyawan,
        username_admin: username_admin,
        foto_url: "",
        ktp_url: "",
        npwp_url: "",
        kk_url: "",
        cv_url: "",
        sertifikasi_training_1_url: "",
        sertifikasi_training_2_url: "",
        sertifikasi_training_3_url: "",
        sertifikasi_training_4_url: "",
        rekening_bank_url: "",
        mutasi_rekening_url: "",
        ijasah_url: "",
        transkrip_url: "",
        skck_url: "",
        bpjs_kesehatan_url: "",
        bpjs_ketenagakerjaan_url: "",
        keterangan_kesehatan_url: "",
        surat_pernyataan_kesanggupan_bpjs_url: "",
        keterangan_bpjs_tidak_aktif_url: "",
        peserta_jkn_url: "",
        iuran_jkn_url: "",
        vaksinasi_1_url: "",
        vaksinasi_2_url: "",
        vaksinasi_3_url: "",
        pemadanan_npwp_url: "",
        surat_lamaran_url: "",
        formulir_lamaran_pekerjaan_url: "",
        formulir_okb_url: "",
        status: "dibuat",
        created_at: new Date(),
        form_1_submitted: "belum",
        form_1_submitted_date: "",
        form_2_submitted: "belum",
        form_2_submitted_date: "",
        form_3_submitted: "belum",
        form_3_submitted_date: "",
        is_reviewed_by_hr: "0",
        is_excel_downloaded: "0",
        trial: false,
      });
    });

    if (errors.length > 0) {
      Swal.fire({
        title: "Import gagal",
        html: `<div style="text-align:left">${errors
          .slice(0, 10)
          .map((err) => `- ${err}`)
          .join("<br/>")}</div>`,
        icon: "error",
      });
      return;
    }

    // Dedup NIK dalam batch yang sama (baris terakhir menang)
    const uniqueByNik = new Map();
    payloads.forEach((payload) => {
      uniqueByNik.set(payload.nik, payload);
    });
    const uniquePayloads = Array.from(uniqueByNik.values());

    this.setState({ submiting: true });

    (async () => {
      let createdCount = 0;
      let updatedCount = 0;

      for (const payload of uniquePayloads) {
        const existingDocs = await findEmployeeDocsByNik(
          this.db,
          payload.nik,
          null,
        );

        if (existingDocs.length > 0) {
          const latest = pickLatestEmployeeDoc(existingDocs);
          // Update identitas saja — jangan reset URL / form yang sudah diisi
          await latest.ref.update({
            nik: payload.nik,
            tanggal_lahir: payload.tanggal_lahir,
            status_karyawan: payload.status_karyawan,
            username_admin: payload.username_admin,
            updated_at: new Date(),
          });
          updatedCount++;
        } else {
          await this.db.add(payload);
          createdCount++;
        }
      }

      this.setState({
        submiting: false,
        data_import: "",
      });
      Swal.fire({
        title: "Data Berhasil Dikirim",
        text: `${createdCount} baru, ${updatedCount} diupdate (total ${uniquePayloads.length} NIK).`,
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Oke",
      });
    })().catch((error) => {
      this.setState({ submiting: false });
      Swal.fire({
        title: "Import gagal",
        text: error?.message || "Terjadi kesalahan saat menyimpan data.",
        icon: "error",
      });
    });
  };

  onChange = (e) => {
    // e.preventDefault();
    this.setState({
      data_import: e.target.value,
    });
  };

  onKeyUp = (e) => {
    // Biarkan isi textarea tetap tersimpan setelah paste/ketik.
    return true;
  };

  setTrialSaving = (employeeKey, saving) => {
    this.setState((prev) => ({
      trialSavingKeys: {
        ...(prev.trialSavingKeys || {}),
        [employeeKey]: saving,
      },
    }));
  };

  applyTrialToState = (employeeKey, enabled) => {
    this.setState((prev) => ({
      employees: prev.employees.map((item) =>
        item.key === employeeKey ? { ...item, trial: enabled } : item,
      ),
      employeesAll: prev.employeesAll.map((item) =>
        item.key === employeeKey ? { ...item, trial: enabled } : item,
      ),
      trialSavingKeys: {
        ...(prev.trialSavingKeys || {}),
        [employeeKey]: false,
      },
    }));
  };

  toggleTrial = async (employee, enabled) => {
    const employeeKey = employee && employee.key;
    if (!employeeKey) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: "ID karyawan tidak ditemukan.",
      });
      return;
    }
    if ((this.state.trialSavingKeys || {})[employeeKey]) return;

    const nama = employee.nama_lengkap || employee.nik || "karyawan ini";
    const confirm = await Swal.fire({
      icon: "question",
      title: enabled ? "Aktifkan trial?" : "Nonaktifkan trial?",
      html: enabled
        ? `Validasi OCR dan AI akan diaktifkan untuk <b>${nama}</b>.`
        : `Validasi OCR dan AI akan dimatikan untuk <b>${nama}</b>.`,
      showCancelButton: true,
      confirmButtonText: enabled ? "Aktifkan" : "Nonaktifkan",
      cancelButtonText: "Batal",
      heightAuto: false,
    });
    const confirmed = Boolean(
      confirm && (confirm.isConfirmed === true || confirm.value === true),
    );
    if (!confirmed) return;

    this.setTrialSaving(employeeKey, true);
    Swal.fire({
      title: "Menyimpan...",
      text: "Mohon tunggu sebentar.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      heightAuto: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      await this.db.doc(employeeKey).set(
        {
          trial: enabled,
          updated_at: new Date(),
        },
        { merge: true },
      );
      this.applyTrialToState(employeeKey, enabled);
      await Swal.fire({
        icon: "success",
        title: "Tersimpan",
        text: enabled ? "Trial diaktifkan." : "Trial dinonaktifkan.",
        timer: 1400,
        showConfirmButton: false,
        heightAuto: false,
      });
    } catch (error) {
      console.error("Error updating trial:", error);
      this.setTrialSaving(employeeKey, false);
      Swal.fire({
        title: "Gagal menyimpan",
        text:
          (error && error.message) ||
          "Tidak dapat mengubah status trial untuk user ini.",
        icon: "error",
        heightAuto: false,
      });
    }
  };

  render() {
    const filteredEmployees = this.state.employees.filter((employee) => {
      // ✅ Filter berdasarkan status download
      let matchesDownloadFilter = true;
      if (this.state.downloadFilter === "belum") {
        matchesDownloadFilter = employee.is_excel_downloaded === "0";
      } else if (this.state.downloadFilter === "sudah") {
        matchesDownloadFilter = employee.is_excel_downloaded === "1";
      }

      // ✅ Filter berdasarkan tanggal masuk
      let matchesTanggalMasuk = true;
      if (this.state.tanggalMasukFrom) {
        const fromDate = new Date(this.state.tanggalMasukFrom);
        const employeeDate = employee.tanggal_masuk
          ? new Date(employee.tanggal_masuk)
          : null;
        if (!employeeDate || employeeDate < fromDate) {
          matchesTanggalMasuk = false;
        }
      }
      if (this.state.tanggalMasukTo) {
        const toDate = new Date(this.state.tanggalMasukTo);
        toDate.setHours(23, 59, 59, 999); // Set ke akhir hari
        const employeeDate = employee.tanggal_masuk
          ? new Date(employee.tanggal_masuk)
          : null;
        if (!employeeDate || employeeDate > toDate) {
          matchesTanggalMasuk = false;
        }
      }

      // ✅ Filter berdasarkan status pengisian form
      let matchesFormSubmission = true;
      const { formSubmissionFilter } = this.state;
      if (formSubmissionFilter === "belum_isi") {
        matchesFormSubmission =
          employee.form_1_submitted === "belum" &&
          employee.form_2_submitted === "belum" &&
          employee.form_3_submitted === "belum";
      } else if (formSubmissionFilter === "form1_saja") {
        matchesFormSubmission =
          employee.form_1_submitted === "diisi" &&
          employee.form_2_submitted === "belum" &&
          employee.form_3_submitted === "belum";
      } else if (formSubmissionFilter === "form1_dan_2") {
        matchesFormSubmission =
          employee.form_1_submitted === "diisi" &&
          employee.form_2_submitted === "diisi" &&
          employee.form_3_submitted === "belum";
      } else if (formSubmissionFilter === "form1_2_dan_3") {
        matchesFormSubmission =
          employee.form_1_submitted === "diisi" &&
          employee.form_2_submitted === "diisi" &&
          employee.form_3_submitted === "diisi";
      }
      // "semua" tidak perlu filter, matchesFormSubmission tetap true

      return (
        matchesDownloadFilter && matchesTanggalMasuk && matchesFormSubmission
      );
    });

    return (
      <div className="container-fluid konten admin-page">
        <nav className="main-header-navbar navbar-expand-lg navbar navbar-with-menu bg-white">
          <div className="container-fluid">
            <div className="navbar-wrapper" style={{ width: "100%" }}>
              <div className="navbar-container">
                <div className="navbar-collapse" id="navbar-mobile">
                  <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center logo-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-row">
                        <li className="nav-item mr-auto">
                          <a className="navbar-brand" href="/">
                            <div className="brand-logo">
                              <img
                                alt="Logo"
                                className="logo"
                                src={require("../assets/logos/logo-pas.jpg")}
                              />
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mr-auto bookmark-wrapper d-flex align-items-center header-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-center">
                          <h1 className="font-header">
                            PT. PRAKARSA ALAM SEGAR
                          </h1>
                        </li>
                        <li className="nav-item text-center">
                          <h2 className="font-sub-header">
                            Human Resource Department
                          </h2>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="bookmark-wrapper d-flex align-items-center time-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-right">
                          <span className="font-date">{this.state.date}</span>
                        </li>
                        <li className="nav-item text-right">
                          <span className="font-time">{this.state.time}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="pembatas"></div>
        <section id="floating-label-layouts">
          <div className="row match-height">
            <div className="col-md-12 col-12">
              <div className="card bg-white">
                <div className="card-header">
                  <h4 className="card-title">ADMINISTRATOR DATA KARYAWAN</h4>
                  <div className="mt-2 mb-2">
                    <div className="row">
                      <div className="col-md-3 mb-2">
                        <label
                          htmlFor="downloadFilter"
                          className="mr-2 font-weight-bold"
                        >
                          Filter Status Download:
                        </label>
                        <select
                          id="downloadFilter"
                          className="form-control"
                          value={this.state.downloadFilter}
                          onChange={(e) =>
                            this.setDownloadFilter(e.target.value)
                          }
                        >
                          <option value="belum">Belum Download</option>
                          <option value="sudah">Telah Download</option>
                          <option value="semua">Semua</option>
                        </select>
                      </div>
                      <div className="col-md-3 mb-2">
                        <label
                          htmlFor="formSubmissionFilter"
                          className="mr-2 font-weight-bold"
                        >
                          Filter Status Pengisian:
                        </label>
                        <select
                          id="formSubmissionFilter"
                          className="form-control"
                          value={this.state.formSubmissionFilter}
                          onChange={(e) =>
                            this.setFormSubmissionFilter(e.target.value)
                          }
                        >
                          <option value="semua">Semua</option>
                          <option value="belum_isi">Belum Isi Form</option>
                          <option value="form1_saja">Form 1 Saja</option>
                          <option value="form1_dan_2">Form 1 & 2</option>
                          <option value="form1_2_dan_3">Form 1, 2 & 3</option>
                        </select>
                      </div>
                      <div className="col-md-3 mb-2">
                        <label
                          htmlFor="tanggalMasukFrom"
                          className="mr-2 font-weight-bold"
                        >
                          Tanggal Masuk Dari:
                        </label>
                        <input
                          type="date"
                          id="tanggalMasukFrom"
                          className="form-control"
                          value={this.state.tanggalMasukFrom}
                          onChange={(e) =>
                            this.setTanggalMasukFrom(e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-3 mb-2">
                        <label
                          htmlFor="tanggalMasukTo"
                          className="mr-2 font-weight-bold"
                        >
                          Tanggal Masuk Sampai:
                        </label>
                        <input
                          type="date"
                          id="tanggalMasukTo"
                          className="form-control"
                          value={this.state.tanggalMasukTo}
                          onChange={(e) =>
                            this.setTanggalMasukTo(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="heading-elements">
                    {/* <button
                      onClick={this.updateAllEmployees}
                      type="button"
                      className="btn btn-sm btn-outline-primary mr-2"
                      title="Update semua dokumen karyawan"
                    >
                      Update All
                    </button> */}
                    {/* <button
                      onClick={this.deleteAllWithNpwpUrl}
                      className="btn btn-outline-danger"
                      type="button"
                      disabled={this.state.isLoading}
                    >
                      <i className="bx bx-trash"></i> Hapus Semua Data dengan
                      NPWP URL
                    </button> */}
                    <span>
                      <i className="bx bx-user"></i>{" "}
                      <span>{this.state.login_name}</span>
                    </span>{" "}
                    &nbsp;
                    <button
                      onClick={this.loadEmployees}
                      title="Muat ulang data (tanpa realtime listener)"
                      type="button"
                      className="btn btn-sm btn-outline-secondary mr-1"
                      disabled={this.state.isLoading}
                    >
                      <i className="bx bx-refresh"></i>{" "}
                      {this.state.isLoading ? "Memuat..." : "Refresh"}
                    </button>
                    <button
                      onClick={this.doLogout}
                      title="Logout"
                      type="button"
                      className="btn btn-icon rounded-circle btn-light-danger"
                    >
                      <i className="bx bx-log-out"></i>
                    </button>
                  </div>
                </div>
                <div className="card-content">
                  <div className="card-body">
                    <div className="admin-employee-table">
                    <table className="table table-bordered table-hover mb-0">
                      <colgroup>
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "9%" }} />
                        <col style={{ width: "12%" }} />
                        <col style={{ width: "11%" }} />
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "12%" }} />
                        <col style={{ width: "9%" }} />
                        <col style={{ width: "4.5%" }} />
                        <col style={{ width: "4.5%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>NIK</th>
                          <th>NAMA</th>
                          <th>NO KTP</th>
                          <th>JK</th>
                          <th>TEMPAT LAHIR</th>
                          <th>TANGGAL LAHIR</th>
                          <th>TANGGAL MASUK</th>
                          <th>STATUS PERDATA</th>
                          <th>STATUS</th>
                          <th>STATUS DOWNLOAD</th>
                          <th>TRIAL</th>
                          <th>AKSI</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.employees.length > 0 ? (
                          filteredEmployees.map((employee, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{employee.nik}</td>
                              <td>{employee.nama_lengkap}</td>
                              <td>{employee.nomor_ktp}</td>
                              <td>{employee.jenis_kelamin}</td>
                              <td>{employee.tempat_lahir}</td>
                              <td>{employee.tanggal_lahir}</td>
                              <td>{employee.tanggal_masuk}</td>
                              <td>{employee.status_perdata}</td>
                              <td>
                                {employee.form_1_submitted === "belum" &&
                                employee.form_2_submitted === "belum" ? (
                                  <span className="text-danger">
                                    Belum Mengisi Form
                                  </span>
                                ) : employee.form_1_submitted === "diisi" &&
                                  employee.form_2_submitted === "belum" ? (
                                  <span className="text-success">
                                    Selesai Mengisi Form 1
                                  </span>
                                ) : employee.form_1_submitted === "diisi" &&
                                  employee.form_2_submitted === "diisi" ? (
                                  <span className="text-success">
                                    Selesai Mengisi Form 2
                                  </span>
                                ) : (
                                  <span className="text-info">
                                    Status Tidak Diketahui
                                  </span>
                                )}
                              </td>
                              <td>
                                {employee.is_excel_downloaded === "0" ? (
                                  <span className="text-warning">
                                    Belum Download
                                  </span>
                                ) : employee.is_excel_downloaded === "1" ? (
                                  <span className="text-success">
                                    Sudah Download
                                  </span>
                                ) : (
                                  <span className="text-info">
                                    Status Tidak Diketahui
                                  </span>
                                )}
                              </td>
                              <td className="text-center">
                                {(this.state.trialSavingKeys || {})[
                                  employee.key
                                ] ? (
                                  <i
                                    className="bx bx-loader-alt bx-spin"
                                    title="Menyimpan..."
                                  />
                                ) : (
                                  <input
                                    type="checkbox"
                                    checked={employee.trial === true}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.toggleTrial(
                                        employee,
                                        employee.trial !== true,
                                      );
                                    }}
                                    onChange={() => {}}
                                    title="Aktifkan validasi OCR dan AI untuk user ini"
                                  />
                                )}
                              </td>
                              <td>
                                <button
                                  onClick={this.delete.bind(this, employee.key)}
                                  title="Hapus"
                                  type="button"
                                  className="btn btn-icon rounded-circle btn-light-danger"
                                >
                                  <i className="bx bx-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="13" className="text-center">
                              {this.state.isLoading ? (
                                <span>Loading...</span>
                              ) : (
                                <span>No Data</span>
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    </div>

                    <div className="mb-3">
                      <button
                        onClick={this.downloadExcel}
                        className="btn btn-outline-success mr-2"
                        disabled={this.state.employeesAll.length <= 0}
                        type="button"
                      >
                        <i className="bx bxs-file-doc"></i> Download Excel
                      </button>
                    </div>

                    {/* ✅ TAMBAH: Card untuk import manual */}
                    <div className="card border-info bg-transparent">
                      <div className="card-content">
                        <div className="card-body">
                          <div>
                            <div className="d-flex justify-content-between">
                              <h4>Import Data Excel dari MCU</h4>
                              <a
                                href={require("../assets/templates/template_import_mcu.xlsx")}
                                download
                                className="btn btn-success text-white"
                              >
                                <i className="bx bx-download"></i> Template
                                Import
                              </a>
                            </div>
                            <div className="form-group">
                              <label htmlFor="excel-file-input">
                                Pilih File Excel
                              </label>
                              <input
                                type="file"
                                id="excel-file-input"
                                className="form-control"
                                accept=".xlsx,.xls"
                                onChange={this.handleFileSelect}
                                disabled={this.state.isImporting}
                              />
                              <small className="form-text text-muted">
                                Format yang didukung: .xlsx, .xls
                              </small>
                            </div>

                            {/* ✅ Loading indicator */}
                            {this.state.isImporting && (
                              <div className="alert alert-warning">
                                <i className="bx bx-loader-alt bx-spin"></i>{" "}
                                Memproses file...
                              </div>
                            )}

                            {/* ✅ Preview data */}
                            {this.state.showPreview &&
                              this.state.importPreview.length > 0 && (
                                <div className="alert alert-light border-success">
                                  <h6>
                                    <strong>
                                      Preview Data (
                                      {this.state.importPreview.length} data):
                                    </strong>
                                  </h6>
                                  <div className="table-responsive">
                                    <table className="table table-sm table-bordered">
                                      <thead>
                                        <tr>
                                          <th>No KTP</th>
                                          <th>Nama Lengkap</th>
                                          <th>Jenis Kelamin</th>
                                          <th>Status Karyawan</th>
                                          <th>Data MCU</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.importPreview
                                          .slice(0, 5)
                                          .map((item, index) => (
                                            <tr key={index}>
                                              <td style={{ color: "black" }}>
                                                {item.nomor_ktp_mcu}
                                              </td>
                                              <td style={{ color: "black" }}>
                                                {item.nama_lengkap_mcu}
                                              </td>
                                              <td style={{ color: "black" }}>
                                                {item.jenis_kelamin_mcu}
                                              </td>
                                              <td>
                                                <span
                                                  className="badge badge-primary"
                                                  style={{ color: "white" }}
                                                >
                                                  {item.status_karyawan}
                                                </span>
                                              </td>
                                              <td>
                                                <small
                                                  style={{ color: "black" }}
                                                >
                                                  <span
                                                    role="img"
                                                    aria-label="check mark"
                                                  >
                                                    ✅
                                                  </span>{" "}
                                                  Data MCU Lengkap
                                                </small>
                                              </td>
                                            </tr>
                                          ))}
                                        {this.state.importPreview.length >
                                          5 && (
                                          <tr>
                                            <td
                                              colSpan={5}
                                              className="text-center"
                                              style={{ color: "black" }}
                                            >
                                              ... dan{" "}
                                              {this.state.importPreview.length -
                                                5}{" "}
                                              data lainnya
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  <button
                                    onClick={this.importFromExcel}
                                    className="btn btn-success"
                                    disabled={this.state.isImporting}
                                  >
                                    <i className="bx bx-upload"></i>
                                    {this.state.isImporting
                                      ? " Importing..."
                                      : ` Import Data`}
                                  </button>
                                </div>
                              )}
                          </div>

                          <div>
                            <h4>Import Data Manual</h4>
                            <div className="alert alert-warning mb-1">
                              <div className="row">
                                <div className="col-md-6">
                                  <h5 className="text-white">Cara pengisian</h5>
                                  <span>
                                    <ul>
                                      <li>
                                        Silahkan buka aplikasi seperti excel
                                      </li>
                                      <li>
                                        Kemudian buat data dengan format "NIK (
                                        Nomor KTP ) |
                                        TGL_LAHIR(tanggalbulantahun) |
                                        STATUS_KARYAWAN(staff, nonstaff,
                                        nonstaff helper, atau pkl/magang)"
                                      </li>
                                      <li>
                                        Kemudian copy seluruh data yang ingin
                                        dimasukan
                                      </li>
                                      <li>Kemudian paste di kolom di bawah</li>
                                      <li>Kemudian klik submit</li>
                                      <li>Selesai</li>
                                    </ul>
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <h5 className="text-white">Contoh Data</h5>
                                  <div className="table-responsive admin-import-example">
                                    <table className="table table-sm table-bordered bg-white mb-0">
                                      <tbody>
                                        {[
                                          ["3201290410930006", "04101993", "staff"],
                                          ["3304035908020002", "19082002", "staff"],
                                          ["3603280605970004", "06051997", "staff"],
                                          ["3374015006000001", "10062000", "nonstaff"],
                                          ["3275025010920022", "10101992", "nonstaff"],
                                          ["3272011806980062", "18061998", "nonstaff"],
                                          ["3273231503020002", "15032002", "nonstaff helper"],
                                          ["1809052901970002", "29011997", "pkl/magang"],
                                          ["3201071702950005", "17021995", "pkl/magang"],
                                          ["3273262301010003", "17061998", "pkl/magang"],
                                        ].map((row) => (
                                          <tr key={row[0]}>
                                            <td style={{ color: "black" }}>{row[0]}</td>
                                            <td style={{ color: "black" }}>{row[1]}</td>
                                            <td style={{ color: "black" }}>{row[2]}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <form onSubmit={this.onSubmit}>
                              <fieldset className="form-group">
                                <label htmlFor="import-data">
                                  Data karyawan
                                </label>
                                <textarea
                                  onKeyUp={this.onKeyUp}
                                  name="data_import"
                                  value={this.state.data_import}
                                  onChange={this.onChange}
                                  required
                                  id="import-data"
                                  rows="10"
                                  className="form-control"
                                ></textarea>
                              </fieldset>
                              <button
                                type="submit"
                                className="btn btn-success mr-2"
                              >
                                <i className="bx bx-download"></i> SUBMIT
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Administrator;
